//This file generated by bin/generateIconListDocs.js
import React from 'react';

import AddOutline from '../src/icons/AddOutline'; //action
import AppSelect from '../src/icons/AppSelect'; //action
import Block from '../src/icons/Block'; //action
import CheckOutline from '../src/icons/CheckOutline'; //action
import CloseOutline from '../src/icons/CloseOutline'; //action
import CollaspedFill from '../src/icons/CollaspedFill'; //action
import CollaspedOutline from '../src/icons/CollaspedOutline'; //action
import Combination from '../src/icons/Combination'; //action
import Conversion from '../src/icons/Conversion'; //action
import Copy from '../src/icons/Copy'; //action
import Dragable from '../src/icons/Dragable'; //action
import Edit from '../src/icons/Edit'; //action
import Exit from '../src/icons/Exit'; //action
import ExpandOutline from '../src/icons/ExpandOutline'; //action
import FileDownload from '../src/icons/FileDownload'; //action
import FileUpload from '../src/icons/FileUpload'; //action
import Funnel from '../src/icons/Funnel'; //action
import Gear from '../src/icons/Gear'; //action
import Minus from '../src/icons/Minus'; //action
import MoveDown from '../src/icons/MoveDown'; //action
import MoveUp from '../src/icons/MoveUp'; //action
import Off from '../src/icons/Off'; //action
import OffRound from '../src/icons/OffRound'; //action
import Plus from '../src/icons/Plus'; //action
import Reload from '../src/icons/Reload'; //action
import Search from '../src/icons/Search'; //action
import Send from '../src/icons/Send'; //action
import Setting from '../src/icons/Setting'; //action
import SettingHorizontal from '../src/icons/SettingHorizontal'; //action
import ShareOutline from '../src/icons/ShareOutline'; //action
import ShareRound from '../src/icons/ShareRound'; //action
import Tools from '../src/icons/Tools'; //action
import Trash from '../src/icons/Trash'; //action
import AbTest from '../src/icons/AbTest'; //application
import AdvancedAnalytics from '../src/icons/AdvancedAnalytics'; //application
import Check from '../src/icons/Check'; //application
import Close from '../src/icons/Close'; //application
import Coupon from '../src/icons/Coupon'; //application
import Creative from '../src/icons/Creative'; //application
import CreditCardMinus from '../src/icons/CreditCardMinus'; //application
import CreditCardPlus from '../src/icons/CreditCardPlus'; //application
import Danger from '../src/icons/Danger'; //application
import Dashboard from '../src/icons/Dashboard'; //application
import DataAuthorize from '../src/icons/DataAuthorize'; //application
import Explore from '../src/icons/Explore'; //application
import Growth from '../src/icons/Growth'; //application
import List from '../src/icons/List'; //application
import Menu from '../src/icons/Menu'; //application
import Message from '../src/icons/Message'; //application
import Model from '../src/icons/Model'; //application
import More from '../src/icons/More'; //application
import Others from '../src/icons/Others'; //application
import PublicOpinion from '../src/icons/PublicOpinion'; //application
import PushMessage from '../src/icons/PushMessage'; //application
import Qrcode from '../src/icons/Qrcode'; //application
import Rate from '../src/icons/Rate'; //application
import Shield from '../src/icons/Shield'; //application
import Speaker from '../src/icons/Speaker'; //application
import TableColumn from '../src/icons/TableColumn'; //application
import Tag from '../src/icons/Tag'; //application
import TagAuthorize from '../src/icons/TagAuthorize'; //application
import TagDate from '../src/icons/TagDate'; //application
import TagFilter from '../src/icons/TagFilter'; //application
import TagLock from '../src/icons/TagLock'; //application
import TagNumber from '../src/icons/TagNumber'; //application
import TagUnauthorize from '../src/icons/TagUnauthorize'; //application
import Task from '../src/icons/Task'; //application
import ViewsAuthorize from '../src/icons/ViewsAuthorize'; //application
import ViewsUnauthorize from '../src/icons/ViewsUnauthorize'; //application
import Image from '../src/icons/Image'; //av
import Media from '../src/icons/Media'; //av
import PauseOutline from '../src/icons/PauseOutline'; //av
import PlayOutline from '../src/icons/PlayOutline'; //av
import BarChart from '../src/icons/BarChart'; //charts
import BarLineChart from '../src/icons/BarLineChart'; //charts
import FunnelSteps from '../src/icons/FunnelSteps'; //charts
import FunnelTime from '../src/icons/FunnelTime'; //charts
import FunnelTrend from '../src/icons/FunnelTrend'; //charts
import LineChart from '../src/icons/LineChart'; //charts
import Numbers from '../src/icons/Numbers'; //charts
import PieChart from '../src/icons/PieChart'; //charts
import RelatedMap from '../src/icons/RelatedMap'; //charts
import Scatter from '../src/icons/Scatter'; //charts
import Table from '../src/icons/Table'; //charts
import Treemap from '../src/icons/Treemap'; //charts
import Trend from '../src/icons/Trend'; //charts
import WavePoint from '../src/icons/WavePoint'; //charts
import Device from '../src/icons/Device'; //device
import DeviceOther from '../src/icons/DeviceOther'; //device
import Mobile from '../src/icons/Mobile'; //device
import Pc from '../src/icons/Pc'; //device
import Phone from '../src/icons/Phone'; //device
import PhoneFill from '../src/icons/PhoneFill'; //device
import Storage from '../src/icons/Storage'; //device
import ArowBack from '../src/icons/ArowBack'; //direction
import ArrowDown from '../src/icons/ArrowDown'; //direction
import ArrowDownLine from '../src/icons/ArrowDownLine'; //direction
import ArrowLeft from '../src/icons/ArrowLeft'; //direction
import ArrowLeftLine from '../src/icons/ArrowLeftLine'; //direction
import ArrowRight from '../src/icons/ArrowRight'; //direction
import ArrowRightLine from '../src/icons/ArrowRightLine'; //direction
import ArrowUp from '../src/icons/ArrowUp'; //direction
import ArrowUpLine from '../src/icons/ArrowUpLine'; //direction
import PageEnd from '../src/icons/PageEnd'; //direction
import PageNext from '../src/icons/PageNext'; //direction
import PagePrevious from '../src/icons/PagePrevious'; //direction
import PageTop from '../src/icons/PageTop'; //direction
import Sort from '../src/icons/Sort'; //direction
import SortDown from '../src/icons/SortDown'; //direction
import SortUp from '../src/icons/SortUp'; //direction
import Attachment from '../src/icons/Attachment'; //file
import ChangeList from '../src/icons/ChangeList'; //file
import Code from '../src/icons/Code'; //file
import Detail from '../src/icons/Detail'; //file
import DocPass from '../src/icons/DocPass'; //file
import Email from '../src/icons/Email'; //file
import EmailFill from '../src/icons/EmailFill'; //file
import FolderFill from '../src/icons/FolderFill'; //file
import FolderMove from '../src/icons/FolderMove'; //file
import Page from '../src/icons/Page'; //file
import Paragraph from '../src/icons/Paragraph'; //file
import Project from '../src/icons/Project'; //file
import SingleSource from '../src/icons/SingleSource'; //file
import TextImage from '../src/icons/TextImage'; //file
import Tree from '../src/icons/Tree'; //file
import Branch from '../src/icons/Branch'; //flow
import Random from '../src/icons/Random'; //flow
import Review from '../src/icons/Review'; //flow
import ReviewPass from '../src/icons/ReviewPass'; //flow
import ReviewRefuse from '../src/icons/ReviewRefuse'; //flow
import Split from '../src/icons/Split'; //flow
import Wait from '../src/icons/Wait'; //flow
import Columns from '../src/icons/Columns'; //layout
import Grid from '../src/icons/Grid'; //layout
import OneColumn from '../src/icons/OneColumn'; //layout
import Resize from '../src/icons/Resize'; //layout
import Site from '../src/icons/Site'; //layout
import SiteFill from '../src/icons/SiteFill'; //layout
import ThreeColumns from '../src/icons/ThreeColumns'; //layout
import AddressBookLegacy from '../src/icons/legacy/AddressBook'; //legacy
import AddressBookOLegacy from '../src/icons/legacy/AddressBookO'; //legacy
import AdjustLegacy from '../src/icons/legacy/Adjust'; //legacy
import AdnLegacy from '../src/icons/legacy/Adn'; //legacy
import AlignCenterLegacy from '../src/icons/legacy/AlignCenter'; //legacy
import AlignJustifyLegacy from '../src/icons/legacy/AlignJustify'; //legacy
import AlignLeftLegacy from '../src/icons/legacy/AlignLeft'; //legacy
import AlignRightLegacy from '../src/icons/legacy/AlignRight'; //legacy
import AlipayLegacy from '../src/icons/legacy/Alipay'; //legacy
import AmazonLegacy from '../src/icons/legacy/Amazon'; //legacy
import AmbulanceLegacy from '../src/icons/legacy/Ambulance'; //legacy
import AnchorLegacy from '../src/icons/legacy/Anchor'; //legacy
import AndroidLegacy from '../src/icons/legacy/Android'; //legacy
import Android2Legacy from '../src/icons/legacy/Android2'; //legacy
import AngellistLegacy from '../src/icons/legacy/Angellist'; //legacy
import AngleDoubleDownLegacy from '../src/icons/legacy/AngleDoubleDown'; //legacy
import AngleDoubleLeftLegacy from '../src/icons/legacy/AngleDoubleLeft'; //legacy
import AngleDoubleRightLegacy from '../src/icons/legacy/AngleDoubleRight'; //legacy
import AngleDoubleUpLegacy from '../src/icons/legacy/AngleDoubleUp'; //legacy
import AngleDownLegacy from '../src/icons/legacy/AngleDown'; //legacy
import AngleLeftLegacy from '../src/icons/legacy/AngleLeft'; //legacy
import AngleRightLegacy from '../src/icons/legacy/AngleRight'; //legacy
import AngleUpLegacy from '../src/icons/legacy/AngleUp'; //legacy
import AppleLegacy from '../src/icons/legacy/Apple'; //legacy
import ArchiveLegacy from '../src/icons/legacy/Archive'; //legacy
import AreaChartLegacy from '../src/icons/legacy/AreaChart'; //legacy
import ArrowCircleDownLegacy from '../src/icons/legacy/ArrowCircleDown'; //legacy
import ArrowCircleLeftLegacy from '../src/icons/legacy/ArrowCircleLeft'; //legacy
import ArrowCircleODownLegacy from '../src/icons/legacy/ArrowCircleODown'; //legacy
import ArrowCircleOLeftLegacy from '../src/icons/legacy/ArrowCircleOLeft'; //legacy
import ArrowCircleORightLegacy from '../src/icons/legacy/ArrowCircleORight'; //legacy
import ArrowCircleOUpLegacy from '../src/icons/legacy/ArrowCircleOUp'; //legacy
import ArrowCircleRightLegacy from '../src/icons/legacy/ArrowCircleRight'; //legacy
import ArrowCircleUpLegacy from '../src/icons/legacy/ArrowCircleUp'; //legacy
import ArrowDownLegacy from '../src/icons/legacy/ArrowDown'; //legacy
import ArrowDown2Legacy from '../src/icons/legacy/ArrowDown2'; //legacy
import ArrowDownLineLegacy from '../src/icons/legacy/ArrowDownLine'; //legacy
import ArrowLeftLegacy from '../src/icons/legacy/ArrowLeft'; //legacy
import ArrowLeftLineLegacy from '../src/icons/legacy/ArrowLeftLine'; //legacy
import ArrowRightLegacy from '../src/icons/legacy/ArrowRight'; //legacy
import ArrowRightLineLegacy from '../src/icons/legacy/ArrowRightLine'; //legacy
import ArrowsLegacy from '../src/icons/legacy/Arrows'; //legacy
import ArrowsAltLegacy from '../src/icons/legacy/ArrowsAlt'; //legacy
import ArrowsHLegacy from '../src/icons/legacy/ArrowsH'; //legacy
import ArrowsVLegacy from '../src/icons/legacy/ArrowsV'; //legacy
import ArrowUpLegacy from '../src/icons/legacy/ArrowUp'; //legacy
import ArrowUp2Legacy from '../src/icons/legacy/ArrowUp2'; //legacy
import ArrowUpLineLegacy from '../src/icons/legacy/ArrowUpLine'; //legacy
import AslInterpretingLegacy from '../src/icons/legacy/AslInterpreting'; //legacy
import AssistiveListeningSystemsLegacy from '../src/icons/legacy/AssistiveListeningSystems'; //legacy
import AsteriskLegacy from '../src/icons/legacy/Asterisk'; //legacy
import AtLegacy from '../src/icons/legacy/At'; //legacy
import AttachmentLegacy from '../src/icons/legacy/Attachment'; //legacy
import AttributionLegacy from '../src/icons/legacy/Attribution'; //legacy
import AudioDescriptionLegacy from '../src/icons/legacy/AudioDescription'; //legacy
import AvatarLegacy from '../src/icons/legacy/Avatar'; //legacy
import BackArrowLegacy from '../src/icons/legacy/BackArrow'; //legacy
import BackwardLegacy from '../src/icons/legacy/Backward'; //legacy
import BalanceScaleLegacy from '../src/icons/legacy/BalanceScale'; //legacy
import BanLegacy from '../src/icons/legacy/Ban'; //legacy
import BandcampLegacy from '../src/icons/legacy/Bandcamp'; //legacy
import BankLegacy from '../src/icons/legacy/Bank'; //legacy
import BarChartLegacy from '../src/icons/legacy/BarChart'; //legacy
import BarChartRankingLegacy from '../src/icons/legacy/BarChartRanking'; //legacy
import BarcodeLegacy from '../src/icons/legacy/Barcode'; //legacy
import BarsLegacy from '../src/icons/legacy/Bars'; //legacy
import BatteryLegacy from '../src/icons/legacy/Battery'; //legacy
import Battery0Legacy from '../src/icons/legacy/Battery0'; //legacy
import Battery1Legacy from '../src/icons/legacy/Battery1'; //legacy
import Battery2Legacy from '../src/icons/legacy/Battery2'; //legacy
import Battery3Legacy from '../src/icons/legacy/Battery3'; //legacy
import BedLegacy from '../src/icons/legacy/Bed'; //legacy
import BeerLegacy from '../src/icons/legacy/Beer'; //legacy
import BehanceLegacy from '../src/icons/legacy/Behance'; //legacy
import BehanceSquareLegacy from '../src/icons/legacy/BehanceSquare'; //legacy
import BellLegacy from '../src/icons/legacy/Bell'; //legacy
import BellOLegacy from '../src/icons/legacy/BellO'; //legacy
import BellSlashLegacy from '../src/icons/legacy/BellSlash'; //legacy
import BellSlashOLegacy from '../src/icons/legacy/BellSlashO'; //legacy
import BicycleLegacy from '../src/icons/legacy/Bicycle'; //legacy
import BinocularsLegacy from '../src/icons/legacy/Binoculars'; //legacy
import BirthdayCakeLegacy from '../src/icons/legacy/BirthdayCake'; //legacy
import BitbucketLegacy from '../src/icons/legacy/Bitbucket'; //legacy
import BitbucketSquareLegacy from '../src/icons/legacy/BitbucketSquare'; //legacy
import BlackTieLegacy from '../src/icons/legacy/BlackTie'; //legacy
import BlindLegacy from '../src/icons/legacy/Blind'; //legacy
import BluetoothLegacy from '../src/icons/legacy/Bluetooth'; //legacy
import BluetoothBLegacy from '../src/icons/legacy/BluetoothB'; //legacy
import BoldLegacy from '../src/icons/legacy/Bold'; //legacy
import BoltLegacy from '../src/icons/legacy/Bolt'; //legacy
import BombLegacy from '../src/icons/legacy/Bomb'; //legacy
import BookLegacy from '../src/icons/legacy/Book'; //legacy
import Book2Legacy from '../src/icons/legacy/Book2'; //legacy
import BookmarkLegacy from '../src/icons/legacy/Bookmark'; //legacy
import BookmarkOLegacy from '../src/icons/legacy/BookmarkO'; //legacy
import BrailleLegacy from '../src/icons/legacy/Braille'; //legacy
import BriefcaseLegacy from '../src/icons/legacy/Briefcase'; //legacy
import BtcLegacy from '../src/icons/legacy/Btc'; //legacy
import BtnOffLegacy from '../src/icons/legacy/BtnOff'; //legacy
import BtnOnLegacy from '../src/icons/legacy/BtnOn'; //legacy
import BugLegacy from '../src/icons/legacy/Bug'; //legacy
import BuildingLegacy from '../src/icons/legacy/Building'; //legacy
import Building2Legacy from '../src/icons/legacy/Building2'; //legacy
import BuildingOLegacy from '../src/icons/legacy/BuildingO'; //legacy
import BullhornLegacy from '../src/icons/legacy/Bullhorn'; //legacy
import BullseyeLegacy from '../src/icons/legacy/Bullseye'; //legacy
import BusLegacy from '../src/icons/legacy/Bus'; //legacy
import BuyselladsLegacy from '../src/icons/legacy/Buysellads'; //legacy
import CabLegacy from '../src/icons/legacy/Cab'; //legacy
import CalculatorLegacy from '../src/icons/legacy/Calculator'; //legacy
import CalendarLegacy from '../src/icons/legacy/Calendar'; //legacy
import CalendarCheckOLegacy from '../src/icons/legacy/CalendarCheckO'; //legacy
import CalendarMinusOLegacy from '../src/icons/legacy/CalendarMinusO'; //legacy
import CalendarOLegacy from '../src/icons/legacy/CalendarO'; //legacy
import CalendarPlusOLegacy from '../src/icons/legacy/CalendarPlusO'; //legacy
import CalendarTimesOLegacy from '../src/icons/legacy/CalendarTimesO'; //legacy
import CameraLegacy from '../src/icons/legacy/Camera'; //legacy
import CameraRetroLegacy from '../src/icons/legacy/CameraRetro'; //legacy
import CarLegacy from '../src/icons/legacy/Car'; //legacy
import CaretDownLegacy from '../src/icons/legacy/CaretDown'; //legacy
import CaretLeftLegacy from '../src/icons/legacy/CaretLeft'; //legacy
import CaretRightLegacy from '../src/icons/legacy/CaretRight'; //legacy
import CaretUpLegacy from '../src/icons/legacy/CaretUp'; //legacy
import CartArrowDownLegacy from '../src/icons/legacy/CartArrowDown'; //legacy
import CartPlusLegacy from '../src/icons/legacy/CartPlus'; //legacy
import CcLegacy from '../src/icons/legacy/Cc'; //legacy
import CcAmexLegacy from '../src/icons/legacy/CcAmex'; //legacy
import CcDinersClubLegacy from '../src/icons/legacy/CcDinersClub'; //legacy
import CcDiscoverLegacy from '../src/icons/legacy/CcDiscover'; //legacy
import CcJcbLegacy from '../src/icons/legacy/CcJcb'; //legacy
import CcMastercardLegacy from '../src/icons/legacy/CcMastercard'; //legacy
import CcPaypalLegacy from '../src/icons/legacy/CcPaypal'; //legacy
import CcStripeLegacy from '../src/icons/legacy/CcStripe'; //legacy
import CcVisaLegacy from '../src/icons/legacy/CcVisa'; //legacy
import CertificateLegacy from '../src/icons/legacy/Certificate'; //legacy
import CharacterAreaLegacy from '../src/icons/legacy/CharacterArea'; //legacy
import CharacterAuthorizeLegacy from '../src/icons/legacy/CharacterAuthorize'; //legacy
import ChartsLegacy from '../src/icons/legacy/Charts'; //legacy
import ChartsLineLegacy from '../src/icons/legacy/ChartsLine'; //legacy
import CheckLegacy from '../src/icons/legacy/Check'; //legacy
import Check2Legacy from '../src/icons/legacy/Check2'; //legacy
import CheckCircleLegacy from '../src/icons/legacy/CheckCircle'; //legacy
import CheckCircleOLegacy from '../src/icons/legacy/CheckCircleO'; //legacy
import CheckSquareLegacy from '../src/icons/legacy/CheckSquare'; //legacy
import CheckSquareOLegacy from '../src/icons/legacy/CheckSquareO'; //legacy
import ChevronCircleDownLegacy from '../src/icons/legacy/ChevronCircleDown'; //legacy
import ChevronCircleLeftLegacy from '../src/icons/legacy/ChevronCircleLeft'; //legacy
import ChevronCircleRightLegacy from '../src/icons/legacy/ChevronCircleRight'; //legacy
import ChevronCircleUpLegacy from '../src/icons/legacy/ChevronCircleUp'; //legacy
import ChevronDownLegacy from '../src/icons/legacy/ChevronDown'; //legacy
import ChevronLeftLegacy from '../src/icons/legacy/ChevronLeft'; //legacy
import ChevronRightLegacy from '../src/icons/legacy/ChevronRight'; //legacy
import ChevronUpLegacy from '../src/icons/legacy/ChevronUp'; //legacy
import ChildLegacy from '../src/icons/legacy/Child'; //legacy
import ChromeLegacy from '../src/icons/legacy/Chrome'; //legacy
import CircleLegacy from '../src/icons/legacy/Circle'; //legacy
import CircleOLegacy from '../src/icons/legacy/CircleO'; //legacy
import CircleONotchLegacy from '../src/icons/legacy/CircleONotch'; //legacy
import CircleThinLegacy from '../src/icons/legacy/CircleThin'; //legacy
import ClockOLegacy from '../src/icons/legacy/ClockO'; //legacy
import CloneLegacy from '../src/icons/legacy/Clone'; //legacy
import CloseLegacy from '../src/icons/legacy/Close'; //legacy
import CloseCircleLegacy from '../src/icons/legacy/CloseCircle'; //legacy
import CloudLegacy from '../src/icons/legacy/Cloud'; //legacy
import CloudDownloadLegacy from '../src/icons/legacy/CloudDownload'; //legacy
import CloudUploadLegacy from '../src/icons/legacy/CloudUpload'; //legacy
import CnyLegacy from '../src/icons/legacy/Cny'; //legacy
import CodeLegacy from '../src/icons/legacy/Code'; //legacy
import CodeForkLegacy from '../src/icons/legacy/CodeFork'; //legacy
import CodepenLegacy from '../src/icons/legacy/Codepen'; //legacy
import CodiepieLegacy from '../src/icons/legacy/Codiepie'; //legacy
import CoffeeLegacy from '../src/icons/legacy/Coffee'; //legacy
import CogLegacy from '../src/icons/legacy/Cog'; //legacy
import CogsLegacy from '../src/icons/legacy/Cogs'; //legacy
import CoincideLegacy from '../src/icons/legacy/Coincide'; //legacy
import CollaspedLegacy from '../src/icons/legacy/Collasped'; //legacy
import CollaspedOLegacy from '../src/icons/legacy/CollaspedO'; //legacy
import ColumnsLegacy from '../src/icons/legacy/Columns'; //legacy
import CommentLegacy from '../src/icons/legacy/Comment'; //legacy
import CommentingLegacy from '../src/icons/legacy/Commenting'; //legacy
import CommentingOLegacy from '../src/icons/legacy/CommentingO'; //legacy
import CommentOLegacy from '../src/icons/legacy/CommentO'; //legacy
import CommentsLegacy from '../src/icons/legacy/Comments'; //legacy
import CommentsOLegacy from '../src/icons/legacy/CommentsO'; //legacy
import CompassLegacy from '../src/icons/legacy/Compass'; //legacy
import CompressLegacy from '../src/icons/legacy/Compress'; //legacy
import ConnectdevelopLegacy from '../src/icons/legacy/Connectdevelop'; //legacy
import ContaoLegacy from '../src/icons/legacy/Contao'; //legacy
import CopyLegacy from '../src/icons/legacy/Copy'; //legacy
import CopyOLegacy from '../src/icons/legacy/CopyO'; //legacy
import CopyrightLegacy from '../src/icons/legacy/Copyright'; //legacy
import CreativeLegacy from '../src/icons/legacy/Creative'; //legacy
import CreativeCommonsLegacy from '../src/icons/legacy/CreativeCommons'; //legacy
import CreditCardLegacy from '../src/icons/legacy/CreditCard'; //legacy
import CreditCardAltLegacy from '../src/icons/legacy/CreditCardAlt'; //legacy
import CropLegacy from '../src/icons/legacy/Crop'; //legacy
import CrosshairsLegacy from '../src/icons/legacy/Crosshairs'; //legacy
import Css3Legacy from '../src/icons/legacy/Css3'; //legacy
import CubeLegacy from '../src/icons/legacy/Cube'; //legacy
import CubesLegacy from '../src/icons/legacy/Cubes'; //legacy
import CutLegacy from '../src/icons/legacy/Cut'; //legacy
import CutleryLegacy from '../src/icons/legacy/Cutlery'; //legacy
import DashboardLegacy from '../src/icons/legacy/Dashboard'; //legacy
import DashcubeLegacy from '../src/icons/legacy/Dashcube'; //legacy
import DataAuthorizeLegacy from '../src/icons/legacy/DataAuthorize'; //legacy
import DatabaseLegacy from '../src/icons/legacy/Database'; //legacy
import DataDecreaseLegacy from '../src/icons/legacy/DataDecrease'; //legacy
import DataIncreaseLegacy from '../src/icons/legacy/DataIncrease'; //legacy
import DeafLegacy from '../src/icons/legacy/Deaf'; //legacy
import DedentLegacy from '../src/icons/legacy/Dedent'; //legacy
import DeliciousLegacy from '../src/icons/legacy/Delicious'; //legacy
import DesktopLegacy from '../src/icons/legacy/Desktop'; //legacy
import DetailLegacy from '../src/icons/legacy/Detail'; //legacy
import DeviantartLegacy from '../src/icons/legacy/Deviantart'; //legacy
import DiamondLegacy from '../src/icons/legacy/Diamond'; //legacy
import DiggLegacy from '../src/icons/legacy/Digg'; //legacy
import DotCircleOLegacy from '../src/icons/legacy/DotCircleO'; //legacy
import DownLegacy from '../src/icons/legacy/Down'; //legacy
import DownloadLegacy from '../src/icons/legacy/Download'; //legacy
import Download2Legacy from '../src/icons/legacy/Download2'; //legacy
import DribbbleLegacy from '../src/icons/legacy/Dribbble'; //legacy
import DropboxLegacy from '../src/icons/legacy/Dropbox'; //legacy
import DrupalLegacy from '../src/icons/legacy/Drupal'; //legacy
import EdgeLegacy from '../src/icons/legacy/Edge'; //legacy
import EditLegacy from '../src/icons/legacy/Edit'; //legacy
import Edit2Legacy from '../src/icons/legacy/Edit2'; //legacy
import EercastLegacy from '../src/icons/legacy/Eercast'; //legacy
import EjectLegacy from '../src/icons/legacy/Eject'; //legacy
import EllipsisHLegacy from '../src/icons/legacy/EllipsisH'; //legacy
import EllipsisVLegacy from '../src/icons/legacy/EllipsisV'; //legacy
import EnvelopeLegacy from '../src/icons/legacy/Envelope'; //legacy
import EnvelopeOLegacy from '../src/icons/legacy/EnvelopeO'; //legacy
import EnvelopeOpenLegacy from '../src/icons/legacy/EnvelopeOpen'; //legacy
import EnvelopeOpenOLegacy from '../src/icons/legacy/EnvelopeOpenO'; //legacy
import EnvelopeSquareLegacy from '../src/icons/legacy/EnvelopeSquare'; //legacy
import EnviraLegacy from '../src/icons/legacy/Envira'; //legacy
import EraserLegacy from '../src/icons/legacy/Eraser'; //legacy
import EtsyLegacy from '../src/icons/legacy/Etsy'; //legacy
import EurLegacy from '../src/icons/legacy/Eur'; //legacy
import ExchangeLegacy from '../src/icons/legacy/Exchange'; //legacy
import ExclamationLegacy from '../src/icons/legacy/Exclamation'; //legacy
import ExclamationCircleLegacy from '../src/icons/legacy/ExclamationCircle'; //legacy
import ExclamationCircle2Legacy from '../src/icons/legacy/ExclamationCircle2'; //legacy
import ExclamationTriangleLegacy from '../src/icons/legacy/ExclamationTriangle'; //legacy
import ExitLegacy from '../src/icons/legacy/Exit'; //legacy
import ExpandLegacy from '../src/icons/legacy/Expand'; //legacy
import ExpandOLegacy from '../src/icons/legacy/ExpandO'; //legacy
import ExpeditedsslLegacy from '../src/icons/legacy/Expeditedssl'; //legacy
import ExploreLegacy from '../src/icons/legacy/Explore'; //legacy
import ExportLegacy from '../src/icons/legacy/Export'; //legacy
import ExternalLinkLegacy from '../src/icons/legacy/ExternalLink'; //legacy
import ExternalLinkSquareLegacy from '../src/icons/legacy/ExternalLinkSquare'; //legacy
import EyeLegacy from '../src/icons/legacy/Eye'; //legacy
import EyedropperLegacy from '../src/icons/legacy/Eyedropper'; //legacy
import EyeSlashLegacy from '../src/icons/legacy/EyeSlash'; //legacy
import FaLegacy from '../src/icons/legacy/Fa'; //legacy
import FacebookLegacy from '../src/icons/legacy/Facebook'; //legacy
import FacebookOfficialLegacy from '../src/icons/legacy/FacebookOfficial'; //legacy
import FacebookSquareLegacy from '../src/icons/legacy/FacebookSquare'; //legacy
import FastBackwardLegacy from '../src/icons/legacy/FastBackward'; //legacy
import FastForwardLegacy from '../src/icons/legacy/FastForward'; //legacy
import FaxLegacy from '../src/icons/legacy/Fax'; //legacy
import FemaleLegacy from '../src/icons/legacy/Female'; //legacy
import FighterJetLegacy from '../src/icons/legacy/FighterJet'; //legacy
import FileLegacy from '../src/icons/legacy/File'; //legacy
import FileAudioOLegacy from '../src/icons/legacy/FileAudioO'; //legacy
import FileCodeOLegacy from '../src/icons/legacy/FileCodeO'; //legacy
import FileDownloadLegacy from '../src/icons/legacy/FileDownload'; //legacy
import FileExcelOLegacy from '../src/icons/legacy/FileExcelO'; //legacy
import FileImageOLegacy from '../src/icons/legacy/FileImageO'; //legacy
import FileMovieOLegacy from '../src/icons/legacy/FileMovieO'; //legacy
import FileOLegacy from '../src/icons/legacy/FileO'; //legacy
import FilePdfOLegacy from '../src/icons/legacy/FilePdfO'; //legacy
import FilePowerpointOLegacy from '../src/icons/legacy/FilePowerpointO'; //legacy
import FileTextLegacy from '../src/icons/legacy/FileText'; //legacy
import FileTextOLegacy from '../src/icons/legacy/FileTextO'; //legacy
import FileUploadLegacy from '../src/icons/legacy/FileUpload'; //legacy
import FileWordOLegacy from '../src/icons/legacy/FileWordO'; //legacy
import FileZipOLegacy from '../src/icons/legacy/FileZipO'; //legacy
import FilmLegacy from '../src/icons/legacy/Film'; //legacy
import FilterLegacy from '../src/icons/legacy/Filter'; //legacy
import FireLegacy from '../src/icons/legacy/Fire'; //legacy
import FireExtinguisherLegacy from '../src/icons/legacy/FireExtinguisher'; //legacy
import FirefoxLegacy from '../src/icons/legacy/Firefox'; //legacy
import FirstOrderLegacy from '../src/icons/legacy/FirstOrder'; //legacy
import FiveHundredPxLegacy from '../src/icons/legacy/FiveHundredPx'; //legacy
import FlagLegacy from '../src/icons/legacy/Flag'; //legacy
import FlagCheckeredLegacy from '../src/icons/legacy/FlagCheckered'; //legacy
import FlagOLegacy from '../src/icons/legacy/FlagO'; //legacy
import FlaskLegacy from '../src/icons/legacy/Flask'; //legacy
import FlickrLegacy from '../src/icons/legacy/Flickr'; //legacy
import FlowLegacy from '../src/icons/legacy/Flow'; //legacy
import FolderLegacy from '../src/icons/legacy/Folder'; //legacy
import FolderOLegacy from '../src/icons/legacy/FolderO'; //legacy
import FolderOpenLegacy from '../src/icons/legacy/FolderOpen'; //legacy
import FolderOpenOLegacy from '../src/icons/legacy/FolderOpenO'; //legacy
import FontLegacy from '../src/icons/legacy/Font'; //legacy
import FonticonsLegacy from '../src/icons/legacy/Fonticons'; //legacy
import FortAwesomeLegacy from '../src/icons/legacy/FortAwesome'; //legacy
import ForumbeeLegacy from '../src/icons/legacy/Forumbee'; //legacy
import ForwardLegacy from '../src/icons/legacy/Forward'; //legacy
import FoursquareLegacy from '../src/icons/legacy/Foursquare'; //legacy
import FrameLegacy from '../src/icons/legacy/Frame'; //legacy
import FreeCodeCampLegacy from '../src/icons/legacy/FreeCodeCamp'; //legacy
import FrownOLegacy from '../src/icons/legacy/FrownO'; //legacy
import FutbolOLegacy from '../src/icons/legacy/FutbolO'; //legacy
import GamepadLegacy from '../src/icons/legacy/Gamepad'; //legacy
import GavelLegacy from '../src/icons/legacy/Gavel'; //legacy
import GbpLegacy from '../src/icons/legacy/Gbp'; //legacy
import GeLegacy from '../src/icons/legacy/Ge'; //legacy
import GearLegacy from '../src/icons/legacy/Gear'; //legacy
import Gear2Legacy from '../src/icons/legacy/Gear2'; //legacy
import GearCircleLegacy from '../src/icons/legacy/GearCircle'; //legacy
import Gears2Legacy from '../src/icons/legacy/Gears2'; //legacy
import GenderlessLegacy from '../src/icons/legacy/Genderless'; //legacy
import GetPocketLegacy from '../src/icons/legacy/GetPocket'; //legacy
import GgLegacy from '../src/icons/legacy/Gg'; //legacy
import GgCircleLegacy from '../src/icons/legacy/GgCircle'; //legacy
import GiftLegacy from '../src/icons/legacy/Gift'; //legacy
import GitLegacy from '../src/icons/legacy/Git'; //legacy
import GithubLegacy from '../src/icons/legacy/Github'; //legacy
import GithubAltLegacy from '../src/icons/legacy/GithubAlt'; //legacy
import GithubSquareLegacy from '../src/icons/legacy/GithubSquare'; //legacy
import GitlabLegacy from '../src/icons/legacy/Gitlab'; //legacy
import GitSquareLegacy from '../src/icons/legacy/GitSquare'; //legacy
import GittipLegacy from '../src/icons/legacy/Gittip'; //legacy
import GlassLegacy from '../src/icons/legacy/Glass'; //legacy
import GlideLegacy from '../src/icons/legacy/Glide'; //legacy
import GlideGLegacy from '../src/icons/legacy/GlideG'; //legacy
import GlobeLegacy from '../src/icons/legacy/Globe'; //legacy
import Globe2Legacy from '../src/icons/legacy/Globe2'; //legacy
import GoodLegacy from '../src/icons/legacy/Good'; //legacy
import GoogleLegacy from '../src/icons/legacy/Google'; //legacy
import GooglePlusLegacy from '../src/icons/legacy/GooglePlus'; //legacy
import GooglePlusCircleLegacy from '../src/icons/legacy/GooglePlusCircle'; //legacy
import GooglePlusSquareLegacy from '../src/icons/legacy/GooglePlusSquare'; //legacy
import GoogleWalletLegacy from '../src/icons/legacy/GoogleWallet'; //legacy
import GravLegacy from '../src/icons/legacy/Grav'; //legacy
import GroupLegacy from '../src/icons/legacy/Group'; //legacy
import HandGrabOLegacy from '../src/icons/legacy/HandGrabO'; //legacy
import HandLizardOLegacy from '../src/icons/legacy/HandLizardO'; //legacy
import HandODownLegacy from '../src/icons/legacy/HandODown'; //legacy
import HandOLeftLegacy from '../src/icons/legacy/HandOLeft'; //legacy
import HandORightLegacy from '../src/icons/legacy/HandORight'; //legacy
import HandOUpLegacy from '../src/icons/legacy/HandOUp'; //legacy
import HandPeaceOLegacy from '../src/icons/legacy/HandPeaceO'; //legacy
import HandPointerOLegacy from '../src/icons/legacy/HandPointerO'; //legacy
import HandScissorsOLegacy from '../src/icons/legacy/HandScissorsO'; //legacy
import HandshakeOLegacy from '../src/icons/legacy/HandshakeO'; //legacy
import HandSpockOLegacy from '../src/icons/legacy/HandSpockO'; //legacy
import HandStopOLegacy from '../src/icons/legacy/HandStopO'; //legacy
import HashtagLegacy from '../src/icons/legacy/Hashtag'; //legacy
import HddOLegacy from '../src/icons/legacy/HddO'; //legacy
import HeaderLegacy from '../src/icons/legacy/Header'; //legacy
import HeadphonesLegacy from '../src/icons/legacy/Headphones'; //legacy
import HeartLegacy from '../src/icons/legacy/Heart'; //legacy
import HeartbeatLegacy from '../src/icons/legacy/Heartbeat'; //legacy
import HeartOLegacy from '../src/icons/legacy/HeartO'; //legacy
import HelpOLegacy from '../src/icons/legacy/HelpO'; //legacy
import HistoryLegacy from '../src/icons/legacy/History'; //legacy
import HomeLegacy from '../src/icons/legacy/Home'; //legacy
import HospitalOLegacy from '../src/icons/legacy/HospitalO'; //legacy
import HourglassLegacy from '../src/icons/legacy/Hourglass'; //legacy
import Hourglass1Legacy from '../src/icons/legacy/Hourglass1'; //legacy
import Hourglass2Legacy from '../src/icons/legacy/Hourglass2'; //legacy
import Hourglass3Legacy from '../src/icons/legacy/Hourglass3'; //legacy
import HourglassOLegacy from '../src/icons/legacy/HourglassO'; //legacy
import HouzzLegacy from '../src/icons/legacy/Houzz'; //legacy
import HSquareLegacy from '../src/icons/legacy/HSquare'; //legacy
import Html5Legacy from '../src/icons/legacy/Html5'; //legacy
import ICursorLegacy from '../src/icons/legacy/ICursor'; //legacy
import IdBadgeLegacy from '../src/icons/legacy/IdBadge'; //legacy
import IdCardLegacy from '../src/icons/legacy/IdCard'; //legacy
import IdCardOLegacy from '../src/icons/legacy/IdCardO'; //legacy
import IdInfoLegacy from '../src/icons/legacy/IdInfo'; //legacy
import IdMappingLegacy from '../src/icons/legacy/IdMapping'; //legacy
import IlsLegacy from '../src/icons/legacy/Ils'; //legacy
import ImageLegacy from '../src/icons/legacy/Image'; //legacy
import ImdbLegacy from '../src/icons/legacy/Imdb'; //legacy
import ImportLegacy from '../src/icons/legacy/Import'; //legacy
import InboxLegacy from '../src/icons/legacy/Inbox'; //legacy
import IndentLegacy from '../src/icons/legacy/Indent'; //legacy
import IndustryLegacy from '../src/icons/legacy/Industry'; //legacy
import InfoLegacy from '../src/icons/legacy/Info'; //legacy
import InfoCircleLegacy from '../src/icons/legacy/InfoCircle'; //legacy
import InrLegacy from '../src/icons/legacy/Inr'; //legacy
import InstagramLegacy from '../src/icons/legacy/Instagram'; //legacy
import InternetExplorerLegacy from '../src/icons/legacy/InternetExplorer'; //legacy
import IntersexLegacy from '../src/icons/legacy/Intersex'; //legacy
import IosLegacy from '../src/icons/legacy/Ios'; //legacy
import IoxhostLegacy from '../src/icons/legacy/Ioxhost'; //legacy
import ItalicLegacy from '../src/icons/legacy/Italic'; //legacy
import JoomlaLegacy from '../src/icons/legacy/Joomla'; //legacy
import JsfiddleLegacy from '../src/icons/legacy/Jsfiddle'; //legacy
import KeyLegacy from '../src/icons/legacy/Key'; //legacy
import KeyboardOLegacy from '../src/icons/legacy/KeyboardO'; //legacy
import KrwLegacy from '../src/icons/legacy/Krw'; //legacy
import LanguageLegacy from '../src/icons/legacy/Language'; //legacy
import LaptopLegacy from '../src/icons/legacy/Laptop'; //legacy
import LastfmLegacy from '../src/icons/legacy/Lastfm'; //legacy
import LastfmSquareLegacy from '../src/icons/legacy/LastfmSquare'; //legacy
import LeafLegacy from '../src/icons/legacy/Leaf'; //legacy
import LeanpubLegacy from '../src/icons/legacy/Leanpub'; //legacy
import LeftLegacy from '../src/icons/legacy/Left'; //legacy
import LemonOLegacy from '../src/icons/legacy/LemonO'; //legacy
import LevelDownLegacy from '../src/icons/legacy/LevelDown'; //legacy
import LevelUpLegacy from '../src/icons/legacy/LevelUp'; //legacy
import LightbulbOLegacy from '../src/icons/legacy/LightbulbO'; //legacy
import LineChartLegacy from '../src/icons/legacy/LineChart'; //legacy
import LinkLegacy from '../src/icons/legacy/Link'; //legacy
import LinkedinLegacy from '../src/icons/legacy/Linkedin'; //legacy
import LinkedinSquareLegacy from '../src/icons/legacy/LinkedinSquare'; //legacy
import LinodeLegacy from '../src/icons/legacy/Linode'; //legacy
import LinuxLegacy from '../src/icons/legacy/Linux'; //legacy
import ListLegacy from '../src/icons/legacy/List'; //legacy
import ListAltLegacy from '../src/icons/legacy/ListAlt'; //legacy
import ListOlLegacy from '../src/icons/legacy/ListOl'; //legacy
import ListUlLegacy from '../src/icons/legacy/ListUl'; //legacy
import LocationArrowLegacy from '../src/icons/legacy/LocationArrow'; //legacy
import LockLegacy from '../src/icons/legacy/Lock'; //legacy
import LogoAdsLegacy from '../src/icons/legacy/LogoAds'; //legacy
import LogoAnalyticsLegacy from '../src/icons/legacy/LogoAnalytics'; //legacy
import LogoDmpLegacy from '../src/icons/legacy/LogoDmp'; //legacy
import LogoMobileLegacy from '../src/icons/legacy/LogoMobile'; //legacy
import LogoShopLegacy from '../src/icons/legacy/LogoShop'; //legacy
import LogoSurveyLegacy from '../src/icons/legacy/LogoSurvey'; //legacy
import LogoVideoLegacy from '../src/icons/legacy/LogoVideo'; //legacy
import LongArrowDownLegacy from '../src/icons/legacy/LongArrowDown'; //legacy
import LongArrowLeftLegacy from '../src/icons/legacy/LongArrowLeft'; //legacy
import LongArrowRightLegacy from '../src/icons/legacy/LongArrowRight'; //legacy
import LongArrowUpLegacy from '../src/icons/legacy/LongArrowUp'; //legacy
import LowVisionLegacy from '../src/icons/legacy/LowVision'; //legacy
import MagicLegacy from '../src/icons/legacy/Magic'; //legacy
import Magic2Legacy from '../src/icons/legacy/Magic2'; //legacy
import MagnetLegacy from '../src/icons/legacy/Magnet'; //legacy
import MaleLegacy from '../src/icons/legacy/Male'; //legacy
import MapLegacy from '../src/icons/legacy/Map'; //legacy
import MapMarkerLegacy from '../src/icons/legacy/MapMarker'; //legacy
import MapOLegacy from '../src/icons/legacy/MapO'; //legacy
import MapPinLegacy from '../src/icons/legacy/MapPin'; //legacy
import MapSignsLegacy from '../src/icons/legacy/MapSigns'; //legacy
import MarsLegacy from '../src/icons/legacy/Mars'; //legacy
import MarsDoubleLegacy from '../src/icons/legacy/MarsDouble'; //legacy
import MarsStrokeLegacy from '../src/icons/legacy/MarsStroke'; //legacy
import MarsStrokeHLegacy from '../src/icons/legacy/MarsStrokeH'; //legacy
import MarsStrokeVLegacy from '../src/icons/legacy/MarsStrokeV'; //legacy
import MaxcdnLegacy from '../src/icons/legacy/Maxcdn'; //legacy
import MeanpathLegacy from '../src/icons/legacy/Meanpath'; //legacy
import MediumLegacy from '../src/icons/legacy/Medium'; //legacy
import MedkitLegacy from '../src/icons/legacy/Medkit'; //legacy
import MeetupLegacy from '../src/icons/legacy/Meetup'; //legacy
import MehOLegacy from '../src/icons/legacy/MehO'; //legacy
import MercuryLegacy from '../src/icons/legacy/Mercury'; //legacy
import MicrochipLegacy from '../src/icons/legacy/Microchip'; //legacy
import MicrophoneLegacy from '../src/icons/legacy/Microphone'; //legacy
import MicrophoneSlashLegacy from '../src/icons/legacy/MicrophoneSlash'; //legacy
import MinusLegacy from '../src/icons/legacy/Minus'; //legacy
import MinusCircleLegacy from '../src/icons/legacy/MinusCircle'; //legacy
import MinusSquareLegacy from '../src/icons/legacy/MinusSquare'; //legacy
import MinusSquareOLegacy from '../src/icons/legacy/MinusSquareO'; //legacy
import MixcloudLegacy from '../src/icons/legacy/Mixcloud'; //legacy
import MobileLegacy from '../src/icons/legacy/Mobile'; //legacy
import ModxLegacy from '../src/icons/legacy/Modx'; //legacy
import MoneyLegacy from '../src/icons/legacy/Money'; //legacy
import MoonOLegacy from '../src/icons/legacy/MoonO'; //legacy
import MoreLegacy from '../src/icons/legacy/More'; //legacy
import MortarBoardLegacy from '../src/icons/legacy/MortarBoard'; //legacy
import MotorcycleLegacy from '../src/icons/legacy/Motorcycle'; //legacy
import MousePointerLegacy from '../src/icons/legacy/MousePointer'; //legacy
import MultipleLinesChartLegacy from '../src/icons/legacy/MultipleLinesChart'; //legacy
import MusicLegacy from '../src/icons/legacy/Music'; //legacy
import NeuterLegacy from '../src/icons/legacy/Neuter'; //legacy
import NewspaperOLegacy from '../src/icons/legacy/NewspaperO'; //legacy
import ObjectGroupLegacy from '../src/icons/legacy/ObjectGroup'; //legacy
import ObjectUngroupLegacy from '../src/icons/legacy/ObjectUngroup'; //legacy
import OdnoklassnikiLegacy from '../src/icons/legacy/Odnoklassniki'; //legacy
import OdnoklassnikiSquareLegacy from '../src/icons/legacy/OdnoklassnikiSquare'; //legacy
import OffLegacy from '../src/icons/legacy/Off'; //legacy
import OkCircleLegacy from '../src/icons/legacy/OkCircle'; //legacy
import OpencartLegacy from '../src/icons/legacy/Opencart'; //legacy
import OpenidLegacy from '../src/icons/legacy/Openid'; //legacy
import OperaLegacy from '../src/icons/legacy/Opera'; //legacy
import OptinMonsterLegacy from '../src/icons/legacy/OptinMonster'; //legacy
import OrderFormLegacy from '../src/icons/legacy/OrderForm'; //legacy
import PageEndLegacy from '../src/icons/legacy/PageEnd'; //legacy
import PagelinesLegacy from '../src/icons/legacy/Pagelines'; //legacy
import PageNextLegacy from '../src/icons/legacy/PageNext'; //legacy
import PagePreviousLegacy from '../src/icons/legacy/PagePrevious'; //legacy
import PageTopLegacy from '../src/icons/legacy/PageTop'; //legacy
import PaintBrushLegacy from '../src/icons/legacy/PaintBrush'; //legacy
import PaperclipLegacy from '../src/icons/legacy/Paperclip'; //legacy
import ParagraphLegacy from '../src/icons/legacy/Paragraph'; //legacy
import PasteLegacy from '../src/icons/legacy/Paste'; //legacy
import PauseLegacy from '../src/icons/legacy/Pause'; //legacy
import PauseCircleLegacy from '../src/icons/legacy/PauseCircle'; //legacy
import PauseCircleOLegacy from '../src/icons/legacy/PauseCircleO'; //legacy
import PawLegacy from '../src/icons/legacy/Paw'; //legacy
import PaypalLegacy from '../src/icons/legacy/Paypal'; //legacy
import PcLegacy from '../src/icons/legacy/Pc'; //legacy
import PencilLegacy from '../src/icons/legacy/Pencil'; //legacy
import PencilSquareLegacy from '../src/icons/legacy/PencilSquare'; //legacy
import PeopleGroupLegacy from '../src/icons/legacy/PeopleGroup'; //legacy
import PeoplesLegacy from '../src/icons/legacy/Peoples'; //legacy
import PeoplesMapLegacy from '../src/icons/legacy/PeoplesMap'; //legacy
import PercentLegacy from '../src/icons/legacy/Percent'; //legacy
import PhoneLegacy from '../src/icons/legacy/Phone'; //legacy
import PhoneSquareLegacy from '../src/icons/legacy/PhoneSquare'; //legacy
import PieChartLegacy from '../src/icons/legacy/PieChart'; //legacy
import PiedPiperLegacy from '../src/icons/legacy/PiedPiper'; //legacy
import PiedPiperAltLegacy from '../src/icons/legacy/PiedPiperAlt'; //legacy
import PiedPiperPpLegacy from '../src/icons/legacy/PiedPiperPp'; //legacy
import PinterestLegacy from '../src/icons/legacy/Pinterest'; //legacy
import PinterestPLegacy from '../src/icons/legacy/PinterestP'; //legacy
import PinterestSquareLegacy from '../src/icons/legacy/PinterestSquare'; //legacy
import PlaneLegacy from '../src/icons/legacy/Plane'; //legacy
import PlayLegacy from '../src/icons/legacy/Play'; //legacy
import Play2Legacy from '../src/icons/legacy/Play2'; //legacy
import PlayCircleLegacy from '../src/icons/legacy/PlayCircle'; //legacy
import PlayCircleOLegacy from '../src/icons/legacy/PlayCircleO'; //legacy
import PlugLegacy from '../src/icons/legacy/Plug'; //legacy
import PlusLegacy from '../src/icons/legacy/Plus'; //legacy
import PlusCircleLegacy from '../src/icons/legacy/PlusCircle'; //legacy
import PlusSquareLegacy from '../src/icons/legacy/PlusSquare'; //legacy
import PlusSquareOLegacy from '../src/icons/legacy/PlusSquareO'; //legacy
import PodcastLegacy from '../src/icons/legacy/Podcast'; //legacy
import PowerOffLegacy from '../src/icons/legacy/PowerOff'; //legacy
import PrintLegacy from '../src/icons/legacy/Print'; //legacy
import ProductHuntLegacy from '../src/icons/legacy/ProductHunt'; //legacy
import ProfileLegacy from '../src/icons/legacy/Profile'; //legacy
import ProjectLegacy from '../src/icons/legacy/Project'; //legacy
import PublicOpinionLegacy from '../src/icons/legacy/PublicOpinion'; //legacy
import PuzzlePieceLegacy from '../src/icons/legacy/PuzzlePiece'; //legacy
import QqLegacy from '../src/icons/legacy/Qq'; //legacy
import QrcodeLegacy from '../src/icons/legacy/Qrcode'; //legacy
import QuestionLegacy from '../src/icons/legacy/Question'; //legacy
import Question2Legacy from '../src/icons/legacy/Question2'; //legacy
import QuestionCircleLegacy from '../src/icons/legacy/QuestionCircle'; //legacy
import QuestionCircle2Legacy from '../src/icons/legacy/QuestionCircle2'; //legacy
import QuoraLegacy from '../src/icons/legacy/Quora'; //legacy
import QuoteLeftLegacy from '../src/icons/legacy/QuoteLeft'; //legacy
import QuoteRightLegacy from '../src/icons/legacy/QuoteRight'; //legacy
import RaLegacy from '../src/icons/legacy/Ra'; //legacy
import RandomLegacy from '../src/icons/legacy/Random'; //legacy
import RateLegacy from '../src/icons/legacy/Rate'; //legacy
import RavelryLegacy from '../src/icons/legacy/Ravelry'; //legacy
import RealtimeLegacy from '../src/icons/legacy/Realtime'; //legacy
import RecycleLegacy from '../src/icons/legacy/Recycle'; //legacy
import RedditLegacy from '../src/icons/legacy/Reddit'; //legacy
import RedditAlienLegacy from '../src/icons/legacy/RedditAlien'; //legacy
import RedditSquareLegacy from '../src/icons/legacy/RedditSquare'; //legacy
import RefreshLegacy from '../src/icons/legacy/Refresh'; //legacy
import Refresh2Legacy from '../src/icons/legacy/Refresh2'; //legacy
import RegisteredLegacy from '../src/icons/legacy/Registered'; //legacy
import RelatedMapLegacy from '../src/icons/legacy/RelatedMap'; //legacy
import ReloadLegacy from '../src/icons/legacy/Reload'; //legacy
import RemindLegacy from '../src/icons/legacy/Remind'; //legacy
import RenrenLegacy from '../src/icons/legacy/Renren'; //legacy
import RepeatLegacy from '../src/icons/legacy/Repeat'; //legacy
import ReplyLegacy from '../src/icons/legacy/Reply'; //legacy
import ReplyAllLegacy from '../src/icons/legacy/ReplyAll'; //legacy
import RetentionLegacy from '../src/icons/legacy/Retention'; //legacy
import RetweetLegacy from '../src/icons/legacy/Retweet'; //legacy
import RightLegacy from '../src/icons/legacy/Right'; //legacy
import RoadLegacy from '../src/icons/legacy/Road'; //legacy
import RocketLegacy from '../src/icons/legacy/Rocket'; //legacy
import RssLegacy from '../src/icons/legacy/Rss'; //legacy
import RssSquareLegacy from '../src/icons/legacy/RssSquare'; //legacy
import RubLegacy from '../src/icons/legacy/Rub'; //legacy
import S15Legacy from '../src/icons/legacy/S15'; //legacy
import SafariLegacy from '../src/icons/legacy/Safari'; //legacy
import SalesLegacy from '../src/icons/legacy/Sales'; //legacy
import SaveLegacy from '../src/icons/legacy/Save'; //legacy
import ScribdLegacy from '../src/icons/legacy/Scribd'; //legacy
import SearchLegacy from '../src/icons/legacy/Search'; //legacy
import SearchMinusLegacy from '../src/icons/legacy/SearchMinus'; //legacy
import SearchPeoplesLegacy from '../src/icons/legacy/SearchPeoples'; //legacy
import SearchPlusLegacy from '../src/icons/legacy/SearchPlus'; //legacy
import SellsyLegacy from '../src/icons/legacy/Sellsy'; //legacy
import SendLegacy from '../src/icons/legacy/Send'; //legacy
import SendOLegacy from '../src/icons/legacy/SendO'; //legacy
import SequenceLegacy from '../src/icons/legacy/Sequence'; //legacy
import SequenceDownLegacy from '../src/icons/legacy/SequenceDown'; //legacy
import SequenceUpLegacy from '../src/icons/legacy/SequenceUp'; //legacy
import ServerLegacy from '../src/icons/legacy/Server'; //legacy
import SettingLegacy from '../src/icons/legacy/Setting'; //legacy
import ShapesLegacy from '../src/icons/legacy/Shapes'; //legacy
import ShareLegacy from '../src/icons/legacy/Share'; //legacy
import Share2Legacy from '../src/icons/legacy/Share2'; //legacy
import ShareAltLegacy from '../src/icons/legacy/ShareAlt'; //legacy
import ShareAltSquareLegacy from '../src/icons/legacy/ShareAltSquare'; //legacy
import ShareSquareLegacy from '../src/icons/legacy/ShareSquare'; //legacy
import ShareSquareOLegacy from '../src/icons/legacy/ShareSquareO'; //legacy
import ShieldLegacy from '../src/icons/legacy/Shield'; //legacy
import ShipLegacy from '../src/icons/legacy/Ship'; //legacy
import ShirtsinbulkLegacy from '../src/icons/legacy/Shirtsinbulk'; //legacy
import ShoppingBagLegacy from '../src/icons/legacy/ShoppingBag'; //legacy
import ShoppingBasketLegacy from '../src/icons/legacy/ShoppingBasket'; //legacy
import ShoppingCartLegacy from '../src/icons/legacy/ShoppingCart'; //legacy
import ShowerLegacy from '../src/icons/legacy/Shower'; //legacy
import SignalLegacy from '../src/icons/legacy/Signal'; //legacy
import SignInLegacy from '../src/icons/legacy/SignIn'; //legacy
import SigningLegacy from '../src/icons/legacy/Signing'; //legacy
import SignOutLegacy from '../src/icons/legacy/SignOut'; //legacy
import SimplybuiltLegacy from '../src/icons/legacy/Simplybuilt'; //legacy
import SitemapLegacy from '../src/icons/legacy/Sitemap'; //legacy
import SkyatlasLegacy from '../src/icons/legacy/Skyatlas'; //legacy
import SkypeLegacy from '../src/icons/legacy/Skype'; //legacy
import SlackLegacy from '../src/icons/legacy/Slack'; //legacy
import SlidersLegacy from '../src/icons/legacy/Sliders'; //legacy
import SlideshareLegacy from '../src/icons/legacy/Slideshare'; //legacy
import SmileOLegacy from '../src/icons/legacy/SmileO'; //legacy
import SnapchatLegacy from '../src/icons/legacy/Snapchat'; //legacy
import SnapchatGhostLegacy from '../src/icons/legacy/SnapchatGhost'; //legacy
import SnapchatSquareLegacy from '../src/icons/legacy/SnapchatSquare'; //legacy
import SnowflakeOLegacy from '../src/icons/legacy/SnowflakeO'; //legacy
import SortLegacy from '../src/icons/legacy/Sort'; //legacy
import SortAlphaAscLegacy from '../src/icons/legacy/SortAlphaAsc'; //legacy
import SortAlphaDescLegacy from '../src/icons/legacy/SortAlphaDesc'; //legacy
import SortAmountAscLegacy from '../src/icons/legacy/SortAmountAsc'; //legacy
import SortAmountDescLegacy from '../src/icons/legacy/SortAmountDesc'; //legacy
import SortDescLegacy from '../src/icons/legacy/SortDesc'; //legacy
import SortNumericAscLegacy from '../src/icons/legacy/SortNumericAsc'; //legacy
import SortNumericDescLegacy from '../src/icons/legacy/SortNumericDesc'; //legacy
import SortUpLegacy from '../src/icons/legacy/SortUp'; //legacy
import SoundcloudLegacy from '../src/icons/legacy/Soundcloud'; //legacy
import SpaceShuttleLegacy from '../src/icons/legacy/SpaceShuttle'; //legacy
import SpeakerLegacy from '../src/icons/legacy/Speaker'; //legacy
import SpinnerLegacy from '../src/icons/legacy/Spinner'; //legacy
import SpoonLegacy from '../src/icons/legacy/Spoon'; //legacy
import SpotifyLegacy from '../src/icons/legacy/Spotify'; //legacy
import SquareLegacy from '../src/icons/legacy/Square'; //legacy
import SquareOLegacy from '../src/icons/legacy/SquareO'; //legacy
import SquaresLegacy from '../src/icons/legacy/Squares'; //legacy
import StackExchangeLegacy from '../src/icons/legacy/StackExchange'; //legacy
import StackOverflowLegacy from '../src/icons/legacy/StackOverflow'; //legacy
import StarLegacy from '../src/icons/legacy/Star'; //legacy
import StarHalfLegacy from '../src/icons/legacy/StarHalf'; //legacy
import StarHalfOLegacy from '../src/icons/legacy/StarHalfO'; //legacy
import StarOLegacy from '../src/icons/legacy/StarO'; //legacy
import SteamLegacy from '../src/icons/legacy/Steam'; //legacy
import SteamSquareLegacy from '../src/icons/legacy/SteamSquare'; //legacy
import StepBackwardLegacy from '../src/icons/legacy/StepBackward'; //legacy
import StepForwardLegacy from '../src/icons/legacy/StepForward'; //legacy
import StethoscopeLegacy from '../src/icons/legacy/Stethoscope'; //legacy
import StickyNoteLegacy from '../src/icons/legacy/StickyNote'; //legacy
import StickyNoteOLegacy from '../src/icons/legacy/StickyNoteO'; //legacy
import StopLegacy from '../src/icons/legacy/Stop'; //legacy
import Stop2Legacy from '../src/icons/legacy/Stop2'; //legacy
import StopCircleLegacy from '../src/icons/legacy/StopCircle'; //legacy
import StopCircleOLegacy from '../src/icons/legacy/StopCircleO'; //legacy
import StreetViewLegacy from '../src/icons/legacy/StreetView'; //legacy
import StrikethroughLegacy from '../src/icons/legacy/Strikethrough'; //legacy
import StumbleuponLegacy from '../src/icons/legacy/Stumbleupon'; //legacy
import StumbleuponCircleLegacy from '../src/icons/legacy/StumbleuponCircle'; //legacy
import SubscriptLegacy from '../src/icons/legacy/Subscript'; //legacy
import SubwayLegacy from '../src/icons/legacy/Subway'; //legacy
import SuitcaseLegacy from '../src/icons/legacy/Suitcase'; //legacy
import SunOLegacy from '../src/icons/legacy/SunO'; //legacy
import SuperpowersLegacy from '../src/icons/legacy/Superpowers'; //legacy
import SuperscriptLegacy from '../src/icons/legacy/Superscript'; //legacy
import SupportLegacy from '../src/icons/legacy/Support'; //legacy
import TableLegacy from '../src/icons/legacy/Table'; //legacy
import TabletLegacy from '../src/icons/legacy/Tablet'; //legacy
import TagLegacy from '../src/icons/legacy/Tag'; //legacy
import TagAreaLegacy from '../src/icons/legacy/TagArea'; //legacy
import TagAuthorizeLegacy from '../src/icons/legacy/TagAuthorize'; //legacy
import TagsLegacy from '../src/icons/legacy/Tags'; //legacy
import TagUnauthorizeLegacy from '../src/icons/legacy/TagUnauthorize'; //legacy
import TargetLegacy from '../src/icons/legacy/Target'; //legacy
import TaskLegacy from '../src/icons/legacy/Task'; //legacy
import TasksLegacy from '../src/icons/legacy/Tasks'; //legacy
import TelegramLegacy from '../src/icons/legacy/Telegram'; //legacy
import TencentWeiboLegacy from '../src/icons/legacy/TencentWeibo'; //legacy
import TerminalLegacy from '../src/icons/legacy/Terminal'; //legacy
import TerminalLineLegacy from '../src/icons/legacy/TerminalLine'; //legacy
import TextHeightLegacy from '../src/icons/legacy/TextHeight'; //legacy
import TextWidthLegacy from '../src/icons/legacy/TextWidth'; //legacy
import ThLegacy from '../src/icons/legacy/Th'; //legacy
import Th2Legacy from '../src/icons/legacy/Th2'; //legacy
import ThemeisleLegacy from '../src/icons/legacy/Themeisle'; //legacy
import ThermometerLegacy from '../src/icons/legacy/Thermometer'; //legacy
import Thermometer0Legacy from '../src/icons/legacy/Thermometer0'; //legacy
import Thermometer1Legacy from '../src/icons/legacy/Thermometer1'; //legacy
import Thermometer2Legacy from '../src/icons/legacy/Thermometer2'; //legacy
import Thermometer3Legacy from '../src/icons/legacy/Thermometer3'; //legacy
import ThLargeLegacy from '../src/icons/legacy/ThLarge'; //legacy
import ThListLegacy from '../src/icons/legacy/ThList'; //legacy
import ThumbsDownLegacy from '../src/icons/legacy/ThumbsDown'; //legacy
import ThumbsODownLegacy from '../src/icons/legacy/ThumbsODown'; //legacy
import ThumbsOUpLegacy from '../src/icons/legacy/ThumbsOUp'; //legacy
import ThumbsUpLegacy from '../src/icons/legacy/ThumbsUp'; //legacy
import ThumbTackLegacy from '../src/icons/legacy/ThumbTack'; //legacy
import TicketLegacy from '../src/icons/legacy/Ticket'; //legacy
import TimesCircleLegacy from '../src/icons/legacy/TimesCircle'; //legacy
import TimesCircleOLegacy from '../src/icons/legacy/TimesCircleO'; //legacy
import TintLegacy from '../src/icons/legacy/Tint'; //legacy
import TmallLegacy from '../src/icons/legacy/Tmall'; //legacy
import ToggleDownLegacy from '../src/icons/legacy/ToggleDown'; //legacy
import ToggleLeftLegacy from '../src/icons/legacy/ToggleLeft'; //legacy
import ToggleOffLegacy from '../src/icons/legacy/ToggleOff'; //legacy
import ToggleOnLegacy from '../src/icons/legacy/ToggleOn'; //legacy
import ToggleRightLegacy from '../src/icons/legacy/ToggleRight'; //legacy
import ToggleUpLegacy from '../src/icons/legacy/ToggleUp'; //legacy
import TrademarkLegacy from '../src/icons/legacy/Trademark'; //legacy
import TrainLegacy from '../src/icons/legacy/Train'; //legacy
import TransgenderAltLegacy from '../src/icons/legacy/TransgenderAlt'; //legacy
import TrashLegacy from '../src/icons/legacy/Trash'; //legacy
import Trash2Legacy from '../src/icons/legacy/Trash2'; //legacy
import TrashOLegacy from '../src/icons/legacy/TrashO'; //legacy
import TreeLegacy from '../src/icons/legacy/Tree'; //legacy
import TreeCloseLegacy from '../src/icons/legacy/TreeClose'; //legacy
import TreeOpenLegacy from '../src/icons/legacy/TreeOpen'; //legacy
import TrelloLegacy from '../src/icons/legacy/Trello'; //legacy
import TrendLegacy from '../src/icons/legacy/Trend'; //legacy
import TripadvisorLegacy from '../src/icons/legacy/Tripadvisor'; //legacy
import TrophyLegacy from '../src/icons/legacy/Trophy'; //legacy
import TruckLegacy from '../src/icons/legacy/Truck'; //legacy
import TryLegacy from '../src/icons/legacy/Try'; //legacy
import TtyLegacy from '../src/icons/legacy/Tty'; //legacy
import TumblrLegacy from '../src/icons/legacy/Tumblr'; //legacy
import TumblrSquareLegacy from '../src/icons/legacy/TumblrSquare'; //legacy
import TvLegacy from '../src/icons/legacy/Tv'; //legacy
import TwinkleStarLegacy from '../src/icons/legacy/TwinkleStar'; //legacy
import TwitchLegacy from '../src/icons/legacy/Twitch'; //legacy
import TwitterLegacy from '../src/icons/legacy/Twitter'; //legacy
import TwitterSquareLegacy from '../src/icons/legacy/TwitterSquare'; //legacy
import UmbrellaLegacy from '../src/icons/legacy/Umbrella'; //legacy
import UnderlineLegacy from '../src/icons/legacy/Underline'; //legacy
import UndoLegacy from '../src/icons/legacy/Undo'; //legacy
import UniversalAccessLegacy from '../src/icons/legacy/UniversalAccess'; //legacy
import UnlinkLegacy from '../src/icons/legacy/Unlink'; //legacy
import UnlockLegacy from '../src/icons/legacy/Unlock'; //legacy
import UnlockAltLegacy from '../src/icons/legacy/UnlockAlt'; //legacy
import UpLegacy from '../src/icons/legacy/Up'; //legacy
import UploadLegacy from '../src/icons/legacy/Upload'; //legacy
import Upload2Legacy from '../src/icons/legacy/Upload2'; //legacy
import UsbLegacy from '../src/icons/legacy/Usb'; //legacy
import UsdLegacy from '../src/icons/legacy/Usd'; //legacy
import UserLegacy from '../src/icons/legacy/User'; //legacy
import UserAnalysisLegacy from '../src/icons/legacy/UserAnalysis'; //legacy
import UserCircleLegacy from '../src/icons/legacy/UserCircle'; //legacy
import UserCircleOLegacy from '../src/icons/legacy/UserCircleO'; //legacy
import UserInfoLegacy from '../src/icons/legacy/UserInfo'; //legacy
import UserMdLegacy from '../src/icons/legacy/UserMd'; //legacy
import UserOLegacy from '../src/icons/legacy/UserO'; //legacy
import UserPlusLegacy from '../src/icons/legacy/UserPlus'; //legacy
import UserSecretLegacy from '../src/icons/legacy/UserSecret'; //legacy
import UserTimesLegacy from '../src/icons/legacy/UserTimes'; //legacy
import VcardLegacy from '../src/icons/legacy/Vcard'; //legacy
import VcardOLegacy from '../src/icons/legacy/VcardO'; //legacy
import VenusLegacy from '../src/icons/legacy/Venus'; //legacy
import VenusDoubleLegacy from '../src/icons/legacy/VenusDouble'; //legacy
import VenusMarsLegacy from '../src/icons/legacy/VenusMars'; //legacy
import ViacoinLegacy from '../src/icons/legacy/Viacoin'; //legacy
import ViadeoLegacy from '../src/icons/legacy/Viadeo'; //legacy
import ViadeoSquareLegacy from '../src/icons/legacy/ViadeoSquare'; //legacy
import VideoCameraLegacy from '../src/icons/legacy/VideoCamera'; //legacy
import ViewsAuthorizeLegacy from '../src/icons/legacy/ViewsAuthorize'; //legacy
import ViewsUnauthorizeLegacy from '../src/icons/legacy/ViewsUnauthorize'; //legacy
import VimeoLegacy from '../src/icons/legacy/Vimeo'; //legacy
import VimeoSquareLegacy from '../src/icons/legacy/VimeoSquare'; //legacy
import VineLegacy from '../src/icons/legacy/Vine'; //legacy
import VkLegacy from '../src/icons/legacy/Vk'; //legacy
import VolumeControlPhoneLegacy from '../src/icons/legacy/VolumeControlPhone'; //legacy
import VolumeDownLegacy from '../src/icons/legacy/VolumeDown'; //legacy
import VolumeOffLegacy from '../src/icons/legacy/VolumeOff'; //legacy
import VolumeUpLegacy from '../src/icons/legacy/VolumeUp'; //legacy
import WarningLegacy from '../src/icons/legacy/Warning'; //legacy
import WeappLegacy from '../src/icons/legacy/Weapp'; //legacy
import WebLegacy from '../src/icons/legacy/Web'; //legacy
import WechatLegacy from '../src/icons/legacy/Wechat'; //legacy
import WeiboLegacy from '../src/icons/legacy/Weibo'; //legacy
import WhatsappLegacy from '../src/icons/legacy/Whatsapp'; //legacy
import WheelchairLegacy from '../src/icons/legacy/Wheelchair'; //legacy
import WheelchairAltLegacy from '../src/icons/legacy/WheelchairAlt'; //legacy
import WifiLegacy from '../src/icons/legacy/Wifi'; //legacy
import WikipediaWLegacy from '../src/icons/legacy/WikipediaW'; //legacy
import WindowCloseLegacy from '../src/icons/legacy/WindowClose'; //legacy
import WindowCloseOLegacy from '../src/icons/legacy/WindowCloseO'; //legacy
import WindowMaximizeLegacy from '../src/icons/legacy/WindowMaximize'; //legacy
import WindowMinimizeLegacy from '../src/icons/legacy/WindowMinimize'; //legacy
import WindowRestoreLegacy from '../src/icons/legacy/WindowRestore'; //legacy
import WindowsLegacy from '../src/icons/legacy/Windows'; //legacy
import WordpressLegacy from '../src/icons/legacy/Wordpress'; //legacy
import WpbeginnerLegacy from '../src/icons/legacy/Wpbeginner'; //legacy
import WpexplorerLegacy from '../src/icons/legacy/Wpexplorer'; //legacy
import WpformsLegacy from '../src/icons/legacy/Wpforms'; //legacy
import WrenchLegacy from '../src/icons/legacy/Wrench'; //legacy
import XingLegacy from '../src/icons/legacy/Xing'; //legacy
import XingSquareLegacy from '../src/icons/legacy/XingSquare'; //legacy
import YahooLegacy from '../src/icons/legacy/Yahoo'; //legacy
import YcLegacy from '../src/icons/legacy/Yc'; //legacy
import YcSquareLegacy from '../src/icons/legacy/YcSquare'; //legacy
import YelpLegacy from '../src/icons/legacy/Yelp'; //legacy
import YoastLegacy from '../src/icons/legacy/Yoast'; //legacy
import YoutubeLegacy from '../src/icons/legacy/Youtube'; //legacy
import YoutubePlayLegacy from '../src/icons/legacy/YoutubePlay'; //legacy
import YoutubeSquareLegacy from '../src/icons/legacy/YoutubeSquare'; //legacy
import CloudReflash from '../src/icons/CloudReflash'; //network
import Export from '../src/icons/Export'; //network
import Global from '../src/icons/Global'; //network
import Import from '../src/icons/Import'; //network
import Admin from '../src/icons/Admin'; //people
import CharacterAuthorize from '../src/icons/CharacterAuthorize'; //people
import CharacterLock from '../src/icons/CharacterLock'; //people
import IdInfo from '../src/icons/IdInfo'; //people
import IdMapping from '../src/icons/IdMapping'; //people
import Location from '../src/icons/Location'; //people
import Member from '../src/icons/Member'; //people
import OperatePeople from '../src/icons/OperatePeople'; //people
import PeopleBranch from '../src/icons/PeopleBranch'; //people
import PeopleExpand from '../src/icons/PeopleExpand'; //people
import PeopleFliter from '../src/icons/PeopleFliter'; //people
import Peoples from '../src/icons/Peoples'; //people
import PeoplesCostomize from '../src/icons/PeoplesCostomize'; //people
import PeoplesMap from '../src/icons/PeoplesMap'; //people
import PeopleSpeaker from '../src/icons/PeopleSpeaker'; //people
import PeoplesUploaded from '../src/icons/PeoplesUploaded'; //people
import SearchPeople from '../src/icons/SearchPeople'; //people
import SentToUser from '../src/icons/SentToUser'; //people
import UserBadge from '../src/icons/UserBadge'; //people
import UserChange from '../src/icons/UserChange'; //people
import UserInfo from '../src/icons/UserInfo'; //people
import Alipay from '../src/icons/Alipay'; //platform
import Android from '../src/icons/Android'; //platform
import IOs from '../src/icons/IOs'; //platform
import MiniProgram from '../src/icons/MiniProgram'; //platform
import Taobao from '../src/icons/Taobao'; //platform
import Tmall from '../src/icons/Tmall'; //platform
import Wechat from '../src/icons/Wechat'; //platform
import WechatOutline from '../src/icons/WechatOutline'; //platform
import WechatTemplate from '../src/icons/WechatTemplate'; //platform
import BlockRound from '../src/icons/BlockRound'; //status
import CheckRound from '../src/icons/CheckRound'; //status
import DoingRound from '../src/icons/DoingRound'; //status
import DraftRound from '../src/icons/DraftRound'; //status
import ExpiredRound from '../src/icons/ExpiredRound'; //status
import EyeClose from '../src/icons/EyeClose'; //status
import HelpOutline from '../src/icons/HelpOutline'; //status
import InfoOutline from '../src/icons/InfoOutline'; //status
import InfoRound from '../src/icons/InfoRound'; //status
import MinusRound from '../src/icons/MinusRound'; //status
import Notice from '../src/icons/Notice'; //status
import PauseRound from '../src/icons/PauseRound'; //status
import Pin from '../src/icons/Pin'; //status
import Pined from '../src/icons/Pined'; //status
import PlusRound from '../src/icons/PlusRound'; //status
import ReadyRound from '../src/icons/ReadyRound'; //status
import RemindFill from '../src/icons/RemindFill'; //status
import RemindOutline from '../src/icons/RemindOutline'; //status
import RemindRound from '../src/icons/RemindRound'; //status
import RunningRound from '../src/icons/RunningRound'; //status
import TimeRound from '../src/icons/TimeRound'; //status
import Unvisible from '../src/icons/Unvisible'; //status
import UpdateRound from '../src/icons/UpdateRound'; //status
import VerifyRound from '../src/icons/VerifyRound'; //status
import Visible from '../src/icons/Visible'; //status
import WarningRound from '../src/icons/WarningRound'; //status
import Calendar from '../src/icons/Calendar'; //time
import EventDetail from '../src/icons/EventDetail'; //time
import History from '../src/icons/History'; //time
import Time from '../src/icons/Time'; //time

const IconList = () => {
  return (
    <div className="icon-list-wrapper">
      <h3>action</h3>
      <ul>
        <li>
          <AddOutline />
          <span className="icon-label">AddOutline</span>
        </li>
        <li>
          <AppSelect />
          <span className="icon-label">AppSelect</span>
        </li>
        <li>
          <Block />
          <span className="icon-label">Block</span>
        </li>
        <li>
          <CheckOutline />
          <span className="icon-label">CheckOutline</span>
        </li>
        <li>
          <CloseOutline />
          <span className="icon-label">CloseOutline</span>
        </li>
        <li>
          <CollaspedFill />
          <span className="icon-label">CollaspedFill</span>
        </li>
        <li>
          <CollaspedOutline />
          <span className="icon-label">CollaspedOutline</span>
        </li>
        <li>
          <Combination />
          <span className="icon-label">Combination</span>
        </li>
        <li>
          <Conversion />
          <span className="icon-label">Conversion</span>
        </li>
        <li>
          <Copy />
          <span className="icon-label">Copy</span>
        </li>
        <li>
          <Dragable />
          <span className="icon-label">Dragable</span>
        </li>
        <li>
          <Edit />
          <span className="icon-label">Edit</span>
        </li>
        <li>
          <Exit />
          <span className="icon-label">Exit</span>
        </li>
        <li>
          <ExpandOutline />
          <span className="icon-label">ExpandOutline</span>
        </li>
        <li>
          <FileDownload />
          <span className="icon-label">FileDownload</span>
        </li>
        <li>
          <FileUpload />
          <span className="icon-label">FileUpload</span>
        </li>
        <li>
          <Funnel />
          <span className="icon-label">Funnel</span>
        </li>
        <li>
          <Gear />
          <span className="icon-label">Gear</span>
        </li>
        <li>
          <Minus />
          <span className="icon-label">Minus</span>
        </li>
        <li>
          <MoveDown />
          <span className="icon-label">MoveDown</span>
        </li>
        <li>
          <MoveUp />
          <span className="icon-label">MoveUp</span>
        </li>
        <li>
          <Off />
          <span className="icon-label">Off</span>
        </li>
        <li>
          <OffRound />
          <span className="icon-label">OffRound</span>
        </li>
        <li>
          <Plus />
          <span className="icon-label">Plus</span>
        </li>
        <li>
          <Reload />
          <span className="icon-label">Reload</span>
        </li>
        <li>
          <Search />
          <span className="icon-label">Search</span>
        </li>
        <li>
          <Send />
          <span className="icon-label">Send</span>
        </li>
        <li>
          <Setting />
          <span className="icon-label">Setting</span>
        </li>
        <li>
          <SettingHorizontal />
          <span className="icon-label">SettingHorizontal</span>
        </li>
        <li>
          <ShareOutline />
          <span className="icon-label">ShareOutline</span>
        </li>
        <li>
          <ShareRound />
          <span className="icon-label">ShareRound</span>
        </li>
        <li>
          <Tools />
          <span className="icon-label">Tools</span>
        </li>
        <li>
          <Trash />
          <span className="icon-label">Trash</span>
        </li>
      </ul>
      <h3>application</h3>
      <ul>
        <li>
          <AbTest />
          <span className="icon-label">AbTest</span>
        </li>
        <li>
          <AdvancedAnalytics />
          <span className="icon-label">AdvancedAnalytics</span>
        </li>
        <li>
          <Check />
          <span className="icon-label">Check</span>
        </li>
        <li>
          <Close />
          <span className="icon-label">Close</span>
        </li>
        <li>
          <Coupon />
          <span className="icon-label">Coupon</span>
        </li>
        <li>
          <Creative />
          <span className="icon-label">Creative</span>
        </li>
        <li>
          <CreditCardMinus />
          <span className="icon-label">CreditCardMinus</span>
        </li>
        <li>
          <CreditCardPlus />
          <span className="icon-label">CreditCardPlus</span>
        </li>
        <li>
          <Danger />
          <span className="icon-label">Danger</span>
        </li>
        <li>
          <Dashboard />
          <span className="icon-label">Dashboard</span>
        </li>
        <li>
          <DataAuthorize />
          <span className="icon-label">DataAuthorize</span>
        </li>
        <li>
          <Explore />
          <span className="icon-label">Explore</span>
        </li>
        <li>
          <Growth />
          <span className="icon-label">Growth</span>
        </li>
        <li>
          <List />
          <span className="icon-label">List</span>
        </li>
        <li>
          <Menu />
          <span className="icon-label">Menu</span>
        </li>
        <li>
          <Message />
          <span className="icon-label">Message</span>
        </li>
        <li>
          <Model />
          <span className="icon-label">Model</span>
        </li>
        <li>
          <More />
          <span className="icon-label">More</span>
        </li>
        <li>
          <Others />
          <span className="icon-label">Others</span>
        </li>
        <li>
          <PublicOpinion />
          <span className="icon-label">PublicOpinion</span>
        </li>
        <li>
          <PushMessage />
          <span className="icon-label">PushMessage</span>
        </li>
        <li>
          <Qrcode />
          <span className="icon-label">Qrcode</span>
        </li>
        <li>
          <Rate />
          <span className="icon-label">Rate</span>
        </li>
        <li>
          <Shield />
          <span className="icon-label">Shield</span>
        </li>
        <li>
          <Speaker />
          <span className="icon-label">Speaker</span>
        </li>
        <li>
          <TableColumn />
          <span className="icon-label">TableColumn</span>
        </li>
        <li>
          <Tag />
          <span className="icon-label">Tag</span>
        </li>
        <li>
          <TagAuthorize />
          <span className="icon-label">TagAuthorize</span>
        </li>
        <li>
          <TagDate />
          <span className="icon-label">TagDate</span>
        </li>
        <li>
          <TagFilter />
          <span className="icon-label">TagFilter</span>
        </li>
        <li>
          <TagLock />
          <span className="icon-label">TagLock</span>
        </li>
        <li>
          <TagNumber />
          <span className="icon-label">TagNumber</span>
        </li>
        <li>
          <TagUnauthorize />
          <span className="icon-label">TagUnauthorize</span>
        </li>
        <li>
          <Task />
          <span className="icon-label">Task</span>
        </li>
        <li>
          <ViewsAuthorize />
          <span className="icon-label">ViewsAuthorize</span>
        </li>
        <li>
          <ViewsUnauthorize />
          <span className="icon-label">ViewsUnauthorize</span>
        </li>
      </ul>
      <h3>av</h3>
      <ul>
        <li>
          <Image />
          <span className="icon-label">Image</span>
        </li>
        <li>
          <Media />
          <span className="icon-label">Media</span>
        </li>
        <li>
          <PauseOutline />
          <span className="icon-label">PauseOutline</span>
        </li>
        <li>
          <PlayOutline />
          <span className="icon-label">PlayOutline</span>
        </li>
      </ul>
      <h3>charts</h3>
      <ul>
        <li>
          <BarChart />
          <span className="icon-label">BarChart</span>
        </li>
        <li>
          <BarLineChart />
          <span className="icon-label">BarLineChart</span>
        </li>
        <li>
          <FunnelSteps />
          <span className="icon-label">FunnelSteps</span>
        </li>
        <li>
          <FunnelTime />
          <span className="icon-label">FunnelTime</span>
        </li>
        <li>
          <FunnelTrend />
          <span className="icon-label">FunnelTrend</span>
        </li>
        <li>
          <LineChart />
          <span className="icon-label">LineChart</span>
        </li>
        <li>
          <Numbers />
          <span className="icon-label">Numbers</span>
        </li>
        <li>
          <PieChart />
          <span className="icon-label">PieChart</span>
        </li>
        <li>
          <RelatedMap />
          <span className="icon-label">RelatedMap</span>
        </li>
        <li>
          <Scatter />
          <span className="icon-label">Scatter</span>
        </li>
        <li>
          <Table />
          <span className="icon-label">Table</span>
        </li>
        <li>
          <Treemap />
          <span className="icon-label">Treemap</span>
        </li>
        <li>
          <Trend />
          <span className="icon-label">Trend</span>
        </li>
        <li>
          <WavePoint />
          <span className="icon-label">WavePoint</span>
        </li>
      </ul>
      <h3>device</h3>
      <ul>
        <li>
          <Device />
          <span className="icon-label">Device</span>
        </li>
        <li>
          <DeviceOther />
          <span className="icon-label">DeviceOther</span>
        </li>
        <li>
          <Mobile />
          <span className="icon-label">Mobile</span>
        </li>
        <li>
          <Pc />
          <span className="icon-label">Pc</span>
        </li>
        <li>
          <Phone />
          <span className="icon-label">Phone</span>
        </li>
        <li>
          <PhoneFill />
          <span className="icon-label">PhoneFill</span>
        </li>
        <li>
          <Storage />
          <span className="icon-label">Storage</span>
        </li>
      </ul>
      <h3>direction</h3>
      <ul>
        <li>
          <ArowBack />
          <span className="icon-label">ArowBack</span>
        </li>
        <li>
          <ArrowDown />
          <span className="icon-label">ArrowDown</span>
        </li>
        <li>
          <ArrowDownLine />
          <span className="icon-label">ArrowDownLine</span>
        </li>
        <li>
          <ArrowLeft />
          <span className="icon-label">ArrowLeft</span>
        </li>
        <li>
          <ArrowLeftLine />
          <span className="icon-label">ArrowLeftLine</span>
        </li>
        <li>
          <ArrowRight />
          <span className="icon-label">ArrowRight</span>
        </li>
        <li>
          <ArrowRightLine />
          <span className="icon-label">ArrowRightLine</span>
        </li>
        <li>
          <ArrowUp />
          <span className="icon-label">ArrowUp</span>
        </li>
        <li>
          <ArrowUpLine />
          <span className="icon-label">ArrowUpLine</span>
        </li>
        <li>
          <PageEnd />
          <span className="icon-label">PageEnd</span>
        </li>
        <li>
          <PageNext />
          <span className="icon-label">PageNext</span>
        </li>
        <li>
          <PagePrevious />
          <span className="icon-label">PagePrevious</span>
        </li>
        <li>
          <PageTop />
          <span className="icon-label">PageTop</span>
        </li>
        <li>
          <Sort />
          <span className="icon-label">Sort</span>
        </li>
        <li>
          <SortDown />
          <span className="icon-label">SortDown</span>
        </li>
        <li>
          <SortUp />
          <span className="icon-label">SortUp</span>
        </li>
      </ul>
      <h3>file</h3>
      <ul>
        <li>
          <Attachment />
          <span className="icon-label">Attachment</span>
        </li>
        <li>
          <ChangeList />
          <span className="icon-label">ChangeList</span>
        </li>
        <li>
          <Code />
          <span className="icon-label">Code</span>
        </li>
        <li>
          <Detail />
          <span className="icon-label">Detail</span>
        </li>
        <li>
          <DocPass />
          <span className="icon-label">DocPass</span>
        </li>
        <li>
          <Email />
          <span className="icon-label">Email</span>
        </li>
        <li>
          <EmailFill />
          <span className="icon-label">EmailFill</span>
        </li>
        <li>
          <FolderFill />
          <span className="icon-label">FolderFill</span>
        </li>
        <li>
          <FolderMove />
          <span className="icon-label">FolderMove</span>
        </li>
        <li>
          <Page />
          <span className="icon-label">Page</span>
        </li>
        <li>
          <Paragraph />
          <span className="icon-label">Paragraph</span>
        </li>
        <li>
          <Project />
          <span className="icon-label">Project</span>
        </li>
        <li>
          <SingleSource />
          <span className="icon-label">SingleSource</span>
        </li>
        <li>
          <TextImage />
          <span className="icon-label">TextImage</span>
        </li>
        <li>
          <Tree />
          <span className="icon-label">Tree</span>
        </li>
      </ul>
      <h3>flow</h3>
      <ul>
        <li>
          <Branch />
          <span className="icon-label">Branch</span>
        </li>
        <li>
          <Random />
          <span className="icon-label">Random</span>
        </li>
        <li>
          <Review />
          <span className="icon-label">Review</span>
        </li>
        <li>
          <ReviewPass />
          <span className="icon-label">ReviewPass</span>
        </li>
        <li>
          <ReviewRefuse />
          <span className="icon-label">ReviewRefuse</span>
        </li>
        <li>
          <Split />
          <span className="icon-label">Split</span>
        </li>
        <li>
          <Wait />
          <span className="icon-label">Wait</span>
        </li>
      </ul>
      <h3>layout</h3>
      <ul>
        <li>
          <Columns />
          <span className="icon-label">Columns</span>
        </li>
        <li>
          <Grid />
          <span className="icon-label">Grid</span>
        </li>
        <li>
          <OneColumn />
          <span className="icon-label">OneColumn</span>
        </li>
        <li>
          <Resize />
          <span className="icon-label">Resize</span>
        </li>
        <li>
          <Site />
          <span className="icon-label">Site</span>
        </li>
        <li>
          <SiteFill />
          <span className="icon-label">SiteFill</span>
        </li>
        <li>
          <ThreeColumns />
          <span className="icon-label">ThreeColumns</span>
        </li>
      </ul>
      <h3>legacy</h3>
      <ul>
        <li>
          <AddressBookLegacy />
          <span className="icon-label">AddressBook</span>
        </li>
        <li>
          <AddressBookOLegacy />
          <span className="icon-label">AddressBookO</span>
        </li>
        <li>
          <AdjustLegacy />
          <span className="icon-label">Adjust</span>
        </li>
        <li>
          <AdnLegacy />
          <span className="icon-label">Adn</span>
        </li>
        <li>
          <AlignCenterLegacy />
          <span className="icon-label">AlignCenter</span>
        </li>
        <li>
          <AlignJustifyLegacy />
          <span className="icon-label">AlignJustify</span>
        </li>
        <li>
          <AlignLeftLegacy />
          <span className="icon-label">AlignLeft</span>
        </li>
        <li>
          <AlignRightLegacy />
          <span className="icon-label">AlignRight</span>
        </li>
        <li>
          <AlipayLegacy />
          <span className="icon-label">Alipay</span>
        </li>
        <li>
          <AmazonLegacy />
          <span className="icon-label">Amazon</span>
        </li>
        <li>
          <AmbulanceLegacy />
          <span className="icon-label">Ambulance</span>
        </li>
        <li>
          <AnchorLegacy />
          <span className="icon-label">Anchor</span>
        </li>
        <li>
          <AndroidLegacy />
          <span className="icon-label">Android</span>
        </li>
        <li>
          <Android2Legacy />
          <span className="icon-label">Android2</span>
        </li>
        <li>
          <AngellistLegacy />
          <span className="icon-label">Angellist</span>
        </li>
        <li>
          <AngleDoubleDownLegacy />
          <span className="icon-label">AngleDoubleDown</span>
        </li>
        <li>
          <AngleDoubleLeftLegacy />
          <span className="icon-label">AngleDoubleLeft</span>
        </li>
        <li>
          <AngleDoubleRightLegacy />
          <span className="icon-label">AngleDoubleRight</span>
        </li>
        <li>
          <AngleDoubleUpLegacy />
          <span className="icon-label">AngleDoubleUp</span>
        </li>
        <li>
          <AngleDownLegacy />
          <span className="icon-label">AngleDown</span>
        </li>
        <li>
          <AngleLeftLegacy />
          <span className="icon-label">AngleLeft</span>
        </li>
        <li>
          <AngleRightLegacy />
          <span className="icon-label">AngleRight</span>
        </li>
        <li>
          <AngleUpLegacy />
          <span className="icon-label">AngleUp</span>
        </li>
        <li>
          <AppleLegacy />
          <span className="icon-label">Apple</span>
        </li>
        <li>
          <ArchiveLegacy />
          <span className="icon-label">Archive</span>
        </li>
        <li>
          <AreaChartLegacy />
          <span className="icon-label">AreaChart</span>
        </li>
        <li>
          <ArrowCircleDownLegacy />
          <span className="icon-label">ArrowCircleDown</span>
        </li>
        <li>
          <ArrowCircleLeftLegacy />
          <span className="icon-label">ArrowCircleLeft</span>
        </li>
        <li>
          <ArrowCircleODownLegacy />
          <span className="icon-label">ArrowCircleODown</span>
        </li>
        <li>
          <ArrowCircleOLeftLegacy />
          <span className="icon-label">ArrowCircleOLeft</span>
        </li>
        <li>
          <ArrowCircleORightLegacy />
          <span className="icon-label">ArrowCircleORight</span>
        </li>
        <li>
          <ArrowCircleOUpLegacy />
          <span className="icon-label">ArrowCircleOUp</span>
        </li>
        <li>
          <ArrowCircleRightLegacy />
          <span className="icon-label">ArrowCircleRight</span>
        </li>
        <li>
          <ArrowCircleUpLegacy />
          <span className="icon-label">ArrowCircleUp</span>
        </li>
        <li>
          <ArrowDownLegacy />
          <span className="icon-label">ArrowDown</span>
        </li>
        <li>
          <ArrowDown2Legacy />
          <span className="icon-label">ArrowDown2</span>
        </li>
        <li>
          <ArrowDownLineLegacy />
          <span className="icon-label">ArrowDownLine</span>
        </li>
        <li>
          <ArrowLeftLegacy />
          <span className="icon-label">ArrowLeft</span>
        </li>
        <li>
          <ArrowLeftLineLegacy />
          <span className="icon-label">ArrowLeftLine</span>
        </li>
        <li>
          <ArrowRightLegacy />
          <span className="icon-label">ArrowRight</span>
        </li>
        <li>
          <ArrowRightLineLegacy />
          <span className="icon-label">ArrowRightLine</span>
        </li>
        <li>
          <ArrowsLegacy />
          <span className="icon-label">Arrows</span>
        </li>
        <li>
          <ArrowsAltLegacy />
          <span className="icon-label">ArrowsAlt</span>
        </li>
        <li>
          <ArrowsHLegacy />
          <span className="icon-label">ArrowsH</span>
        </li>
        <li>
          <ArrowsVLegacy />
          <span className="icon-label">ArrowsV</span>
        </li>
        <li>
          <ArrowUpLegacy />
          <span className="icon-label">ArrowUp</span>
        </li>
        <li>
          <ArrowUp2Legacy />
          <span className="icon-label">ArrowUp2</span>
        </li>
        <li>
          <ArrowUpLineLegacy />
          <span className="icon-label">ArrowUpLine</span>
        </li>
        <li>
          <AslInterpretingLegacy />
          <span className="icon-label">AslInterpreting</span>
        </li>
        <li>
          <AssistiveListeningSystemsLegacy />
          <span className="icon-label">AssistiveListeningSystems</span>
        </li>
        <li>
          <AsteriskLegacy />
          <span className="icon-label">Asterisk</span>
        </li>
        <li>
          <AtLegacy />
          <span className="icon-label">At</span>
        </li>
        <li>
          <AttachmentLegacy />
          <span className="icon-label">Attachment</span>
        </li>
        <li>
          <AttributionLegacy />
          <span className="icon-label">Attribution</span>
        </li>
        <li>
          <AudioDescriptionLegacy />
          <span className="icon-label">AudioDescription</span>
        </li>
        <li>
          <AvatarLegacy />
          <span className="icon-label">Avatar</span>
        </li>
        <li>
          <BackArrowLegacy />
          <span className="icon-label">BackArrow</span>
        </li>
        <li>
          <BackwardLegacy />
          <span className="icon-label">Backward</span>
        </li>
        <li>
          <BalanceScaleLegacy />
          <span className="icon-label">BalanceScale</span>
        </li>
        <li>
          <BanLegacy />
          <span className="icon-label">Ban</span>
        </li>
        <li>
          <BandcampLegacy />
          <span className="icon-label">Bandcamp</span>
        </li>
        <li>
          <BankLegacy />
          <span className="icon-label">Bank</span>
        </li>
        <li>
          <BarChartLegacy />
          <span className="icon-label">BarChart</span>
        </li>
        <li>
          <BarChartRankingLegacy />
          <span className="icon-label">BarChartRanking</span>
        </li>
        <li>
          <BarcodeLegacy />
          <span className="icon-label">Barcode</span>
        </li>
        <li>
          <BarsLegacy />
          <span className="icon-label">Bars</span>
        </li>
        <li>
          <BatteryLegacy />
          <span className="icon-label">Battery</span>
        </li>
        <li>
          <Battery0Legacy />
          <span className="icon-label">Battery0</span>
        </li>
        <li>
          <Battery1Legacy />
          <span className="icon-label">Battery1</span>
        </li>
        <li>
          <Battery2Legacy />
          <span className="icon-label">Battery2</span>
        </li>
        <li>
          <Battery3Legacy />
          <span className="icon-label">Battery3</span>
        </li>
        <li>
          <BedLegacy />
          <span className="icon-label">Bed</span>
        </li>
        <li>
          <BeerLegacy />
          <span className="icon-label">Beer</span>
        </li>
        <li>
          <BehanceLegacy />
          <span className="icon-label">Behance</span>
        </li>
        <li>
          <BehanceSquareLegacy />
          <span className="icon-label">BehanceSquare</span>
        </li>
        <li>
          <BellLegacy />
          <span className="icon-label">Bell</span>
        </li>
        <li>
          <BellOLegacy />
          <span className="icon-label">BellO</span>
        </li>
        <li>
          <BellSlashLegacy />
          <span className="icon-label">BellSlash</span>
        </li>
        <li>
          <BellSlashOLegacy />
          <span className="icon-label">BellSlashO</span>
        </li>
        <li>
          <BicycleLegacy />
          <span className="icon-label">Bicycle</span>
        </li>
        <li>
          <BinocularsLegacy />
          <span className="icon-label">Binoculars</span>
        </li>
        <li>
          <BirthdayCakeLegacy />
          <span className="icon-label">BirthdayCake</span>
        </li>
        <li>
          <BitbucketLegacy />
          <span className="icon-label">Bitbucket</span>
        </li>
        <li>
          <BitbucketSquareLegacy />
          <span className="icon-label">BitbucketSquare</span>
        </li>
        <li>
          <BlackTieLegacy />
          <span className="icon-label">BlackTie</span>
        </li>
        <li>
          <BlindLegacy />
          <span className="icon-label">Blind</span>
        </li>
        <li>
          <BluetoothLegacy />
          <span className="icon-label">Bluetooth</span>
        </li>
        <li>
          <BluetoothBLegacy />
          <span className="icon-label">BluetoothB</span>
        </li>
        <li>
          <BoldLegacy />
          <span className="icon-label">Bold</span>
        </li>
        <li>
          <BoltLegacy />
          <span className="icon-label">Bolt</span>
        </li>
        <li>
          <BombLegacy />
          <span className="icon-label">Bomb</span>
        </li>
        <li>
          <BookLegacy />
          <span className="icon-label">Book</span>
        </li>
        <li>
          <Book2Legacy />
          <span className="icon-label">Book2</span>
        </li>
        <li>
          <BookmarkLegacy />
          <span className="icon-label">Bookmark</span>
        </li>
        <li>
          <BookmarkOLegacy />
          <span className="icon-label">BookmarkO</span>
        </li>
        <li>
          <BrailleLegacy />
          <span className="icon-label">Braille</span>
        </li>
        <li>
          <BriefcaseLegacy />
          <span className="icon-label">Briefcase</span>
        </li>
        <li>
          <BtcLegacy />
          <span className="icon-label">Btc</span>
        </li>
        <li>
          <BtnOffLegacy />
          <span className="icon-label">BtnOff</span>
        </li>
        <li>
          <BtnOnLegacy />
          <span className="icon-label">BtnOn</span>
        </li>
        <li>
          <BugLegacy />
          <span className="icon-label">Bug</span>
        </li>
        <li>
          <BuildingLegacy />
          <span className="icon-label">Building</span>
        </li>
        <li>
          <Building2Legacy />
          <span className="icon-label">Building2</span>
        </li>
        <li>
          <BuildingOLegacy />
          <span className="icon-label">BuildingO</span>
        </li>
        <li>
          <BullhornLegacy />
          <span className="icon-label">Bullhorn</span>
        </li>
        <li>
          <BullseyeLegacy />
          <span className="icon-label">Bullseye</span>
        </li>
        <li>
          <BusLegacy />
          <span className="icon-label">Bus</span>
        </li>
        <li>
          <BuyselladsLegacy />
          <span className="icon-label">Buysellads</span>
        </li>
        <li>
          <CabLegacy />
          <span className="icon-label">Cab</span>
        </li>
        <li>
          <CalculatorLegacy />
          <span className="icon-label">Calculator</span>
        </li>
        <li>
          <CalendarLegacy />
          <span className="icon-label">Calendar</span>
        </li>
        <li>
          <CalendarCheckOLegacy />
          <span className="icon-label">CalendarCheckO</span>
        </li>
        <li>
          <CalendarMinusOLegacy />
          <span className="icon-label">CalendarMinusO</span>
        </li>
        <li>
          <CalendarOLegacy />
          <span className="icon-label">CalendarO</span>
        </li>
        <li>
          <CalendarPlusOLegacy />
          <span className="icon-label">CalendarPlusO</span>
        </li>
        <li>
          <CalendarTimesOLegacy />
          <span className="icon-label">CalendarTimesO</span>
        </li>
        <li>
          <CameraLegacy />
          <span className="icon-label">Camera</span>
        </li>
        <li>
          <CameraRetroLegacy />
          <span className="icon-label">CameraRetro</span>
        </li>
        <li>
          <CarLegacy />
          <span className="icon-label">Car</span>
        </li>
        <li>
          <CaretDownLegacy />
          <span className="icon-label">CaretDown</span>
        </li>
        <li>
          <CaretLeftLegacy />
          <span className="icon-label">CaretLeft</span>
        </li>
        <li>
          <CaretRightLegacy />
          <span className="icon-label">CaretRight</span>
        </li>
        <li>
          <CaretUpLegacy />
          <span className="icon-label">CaretUp</span>
        </li>
        <li>
          <CartArrowDownLegacy />
          <span className="icon-label">CartArrowDown</span>
        </li>
        <li>
          <CartPlusLegacy />
          <span className="icon-label">CartPlus</span>
        </li>
        <li>
          <CcLegacy />
          <span className="icon-label">Cc</span>
        </li>
        <li>
          <CcAmexLegacy />
          <span className="icon-label">CcAmex</span>
        </li>
        <li>
          <CcDinersClubLegacy />
          <span className="icon-label">CcDinersClub</span>
        </li>
        <li>
          <CcDiscoverLegacy />
          <span className="icon-label">CcDiscover</span>
        </li>
        <li>
          <CcJcbLegacy />
          <span className="icon-label">CcJcb</span>
        </li>
        <li>
          <CcMastercardLegacy />
          <span className="icon-label">CcMastercard</span>
        </li>
        <li>
          <CcPaypalLegacy />
          <span className="icon-label">CcPaypal</span>
        </li>
        <li>
          <CcStripeLegacy />
          <span className="icon-label">CcStripe</span>
        </li>
        <li>
          <CcVisaLegacy />
          <span className="icon-label">CcVisa</span>
        </li>
        <li>
          <CertificateLegacy />
          <span className="icon-label">Certificate</span>
        </li>
        <li>
          <CharacterAreaLegacy />
          <span className="icon-label">CharacterArea</span>
        </li>
        <li>
          <CharacterAuthorizeLegacy />
          <span className="icon-label">CharacterAuthorize</span>
        </li>
        <li>
          <ChartsLegacy />
          <span className="icon-label">Charts</span>
        </li>
        <li>
          <ChartsLineLegacy />
          <span className="icon-label">ChartsLine</span>
        </li>
        <li>
          <CheckLegacy />
          <span className="icon-label">Check</span>
        </li>
        <li>
          <Check2Legacy />
          <span className="icon-label">Check2</span>
        </li>
        <li>
          <CheckCircleLegacy />
          <span className="icon-label">CheckCircle</span>
        </li>
        <li>
          <CheckCircleOLegacy />
          <span className="icon-label">CheckCircleO</span>
        </li>
        <li>
          <CheckSquareLegacy />
          <span className="icon-label">CheckSquare</span>
        </li>
        <li>
          <CheckSquareOLegacy />
          <span className="icon-label">CheckSquareO</span>
        </li>
        <li>
          <ChevronCircleDownLegacy />
          <span className="icon-label">ChevronCircleDown</span>
        </li>
        <li>
          <ChevronCircleLeftLegacy />
          <span className="icon-label">ChevronCircleLeft</span>
        </li>
        <li>
          <ChevronCircleRightLegacy />
          <span className="icon-label">ChevronCircleRight</span>
        </li>
        <li>
          <ChevronCircleUpLegacy />
          <span className="icon-label">ChevronCircleUp</span>
        </li>
        <li>
          <ChevronDownLegacy />
          <span className="icon-label">ChevronDown</span>
        </li>
        <li>
          <ChevronLeftLegacy />
          <span className="icon-label">ChevronLeft</span>
        </li>
        <li>
          <ChevronRightLegacy />
          <span className="icon-label">ChevronRight</span>
        </li>
        <li>
          <ChevronUpLegacy />
          <span className="icon-label">ChevronUp</span>
        </li>
        <li>
          <ChildLegacy />
          <span className="icon-label">Child</span>
        </li>
        <li>
          <ChromeLegacy />
          <span className="icon-label">Chrome</span>
        </li>
        <li>
          <CircleLegacy />
          <span className="icon-label">Circle</span>
        </li>
        <li>
          <CircleOLegacy />
          <span className="icon-label">CircleO</span>
        </li>
        <li>
          <CircleONotchLegacy />
          <span className="icon-label">CircleONotch</span>
        </li>
        <li>
          <CircleThinLegacy />
          <span className="icon-label">CircleThin</span>
        </li>
        <li>
          <ClockOLegacy />
          <span className="icon-label">ClockO</span>
        </li>
        <li>
          <CloneLegacy />
          <span className="icon-label">Clone</span>
        </li>
        <li>
          <CloseLegacy />
          <span className="icon-label">Close</span>
        </li>
        <li>
          <CloseCircleLegacy />
          <span className="icon-label">CloseCircle</span>
        </li>
        <li>
          <CloudLegacy />
          <span className="icon-label">Cloud</span>
        </li>
        <li>
          <CloudDownloadLegacy />
          <span className="icon-label">CloudDownload</span>
        </li>
        <li>
          <CloudUploadLegacy />
          <span className="icon-label">CloudUpload</span>
        </li>
        <li>
          <CnyLegacy />
          <span className="icon-label">Cny</span>
        </li>
        <li>
          <CodeLegacy />
          <span className="icon-label">Code</span>
        </li>
        <li>
          <CodeForkLegacy />
          <span className="icon-label">CodeFork</span>
        </li>
        <li>
          <CodepenLegacy />
          <span className="icon-label">Codepen</span>
        </li>
        <li>
          <CodiepieLegacy />
          <span className="icon-label">Codiepie</span>
        </li>
        <li>
          <CoffeeLegacy />
          <span className="icon-label">Coffee</span>
        </li>
        <li>
          <CogLegacy />
          <span className="icon-label">Cog</span>
        </li>
        <li>
          <CogsLegacy />
          <span className="icon-label">Cogs</span>
        </li>
        <li>
          <CoincideLegacy />
          <span className="icon-label">Coincide</span>
        </li>
        <li>
          <CollaspedLegacy />
          <span className="icon-label">Collasped</span>
        </li>
        <li>
          <CollaspedOLegacy />
          <span className="icon-label">CollaspedO</span>
        </li>
        <li>
          <ColumnsLegacy />
          <span className="icon-label">Columns</span>
        </li>
        <li>
          <CommentLegacy />
          <span className="icon-label">Comment</span>
        </li>
        <li>
          <CommentingLegacy />
          <span className="icon-label">Commenting</span>
        </li>
        <li>
          <CommentingOLegacy />
          <span className="icon-label">CommentingO</span>
        </li>
        <li>
          <CommentOLegacy />
          <span className="icon-label">CommentO</span>
        </li>
        <li>
          <CommentsLegacy />
          <span className="icon-label">Comments</span>
        </li>
        <li>
          <CommentsOLegacy />
          <span className="icon-label">CommentsO</span>
        </li>
        <li>
          <CompassLegacy />
          <span className="icon-label">Compass</span>
        </li>
        <li>
          <CompressLegacy />
          <span className="icon-label">Compress</span>
        </li>
        <li>
          <ConnectdevelopLegacy />
          <span className="icon-label">Connectdevelop</span>
        </li>
        <li>
          <ContaoLegacy />
          <span className="icon-label">Contao</span>
        </li>
        <li>
          <CopyLegacy />
          <span className="icon-label">Copy</span>
        </li>
        <li>
          <CopyOLegacy />
          <span className="icon-label">CopyO</span>
        </li>
        <li>
          <CopyrightLegacy />
          <span className="icon-label">Copyright</span>
        </li>
        <li>
          <CreativeLegacy />
          <span className="icon-label">Creative</span>
        </li>
        <li>
          <CreativeCommonsLegacy />
          <span className="icon-label">CreativeCommons</span>
        </li>
        <li>
          <CreditCardLegacy />
          <span className="icon-label">CreditCard</span>
        </li>
        <li>
          <CreditCardAltLegacy />
          <span className="icon-label">CreditCardAlt</span>
        </li>
        <li>
          <CropLegacy />
          <span className="icon-label">Crop</span>
        </li>
        <li>
          <CrosshairsLegacy />
          <span className="icon-label">Crosshairs</span>
        </li>
        <li>
          <Css3Legacy />
          <span className="icon-label">Css3</span>
        </li>
        <li>
          <CubeLegacy />
          <span className="icon-label">Cube</span>
        </li>
        <li>
          <CubesLegacy />
          <span className="icon-label">Cubes</span>
        </li>
        <li>
          <CutLegacy />
          <span className="icon-label">Cut</span>
        </li>
        <li>
          <CutleryLegacy />
          <span className="icon-label">Cutlery</span>
        </li>
        <li>
          <DashboardLegacy />
          <span className="icon-label">Dashboard</span>
        </li>
        <li>
          <DashcubeLegacy />
          <span className="icon-label">Dashcube</span>
        </li>
        <li>
          <DataAuthorizeLegacy />
          <span className="icon-label">DataAuthorize</span>
        </li>
        <li>
          <DatabaseLegacy />
          <span className="icon-label">Database</span>
        </li>
        <li>
          <DataDecreaseLegacy />
          <span className="icon-label">DataDecrease</span>
        </li>
        <li>
          <DataIncreaseLegacy />
          <span className="icon-label">DataIncrease</span>
        </li>
        <li>
          <DeafLegacy />
          <span className="icon-label">Deaf</span>
        </li>
        <li>
          <DedentLegacy />
          <span className="icon-label">Dedent</span>
        </li>
        <li>
          <DeliciousLegacy />
          <span className="icon-label">Delicious</span>
        </li>
        <li>
          <DesktopLegacy />
          <span className="icon-label">Desktop</span>
        </li>
        <li>
          <DetailLegacy />
          <span className="icon-label">Detail</span>
        </li>
        <li>
          <DeviantartLegacy />
          <span className="icon-label">Deviantart</span>
        </li>
        <li>
          <DiamondLegacy />
          <span className="icon-label">Diamond</span>
        </li>
        <li>
          <DiggLegacy />
          <span className="icon-label">Digg</span>
        </li>
        <li>
          <DotCircleOLegacy />
          <span className="icon-label">DotCircleO</span>
        </li>
        <li>
          <DownLegacy />
          <span className="icon-label">Down</span>
        </li>
        <li>
          <DownloadLegacy />
          <span className="icon-label">Download</span>
        </li>
        <li>
          <Download2Legacy />
          <span className="icon-label">Download2</span>
        </li>
        <li>
          <DribbbleLegacy />
          <span className="icon-label">Dribbble</span>
        </li>
        <li>
          <DropboxLegacy />
          <span className="icon-label">Dropbox</span>
        </li>
        <li>
          <DrupalLegacy />
          <span className="icon-label">Drupal</span>
        </li>
        <li>
          <EdgeLegacy />
          <span className="icon-label">Edge</span>
        </li>
        <li>
          <EditLegacy />
          <span className="icon-label">Edit</span>
        </li>
        <li>
          <Edit2Legacy />
          <span className="icon-label">Edit2</span>
        </li>
        <li>
          <EercastLegacy />
          <span className="icon-label">Eercast</span>
        </li>
        <li>
          <EjectLegacy />
          <span className="icon-label">Eject</span>
        </li>
        <li>
          <EllipsisHLegacy />
          <span className="icon-label">EllipsisH</span>
        </li>
        <li>
          <EllipsisVLegacy />
          <span className="icon-label">EllipsisV</span>
        </li>
        <li>
          <EnvelopeLegacy />
          <span className="icon-label">Envelope</span>
        </li>
        <li>
          <EnvelopeOLegacy />
          <span className="icon-label">EnvelopeO</span>
        </li>
        <li>
          <EnvelopeOpenLegacy />
          <span className="icon-label">EnvelopeOpen</span>
        </li>
        <li>
          <EnvelopeOpenOLegacy />
          <span className="icon-label">EnvelopeOpenO</span>
        </li>
        <li>
          <EnvelopeSquareLegacy />
          <span className="icon-label">EnvelopeSquare</span>
        </li>
        <li>
          <EnviraLegacy />
          <span className="icon-label">Envira</span>
        </li>
        <li>
          <EraserLegacy />
          <span className="icon-label">Eraser</span>
        </li>
        <li>
          <EtsyLegacy />
          <span className="icon-label">Etsy</span>
        </li>
        <li>
          <EurLegacy />
          <span className="icon-label">Eur</span>
        </li>
        <li>
          <ExchangeLegacy />
          <span className="icon-label">Exchange</span>
        </li>
        <li>
          <ExclamationLegacy />
          <span className="icon-label">Exclamation</span>
        </li>
        <li>
          <ExclamationCircleLegacy />
          <span className="icon-label">ExclamationCircle</span>
        </li>
        <li>
          <ExclamationCircle2Legacy />
          <span className="icon-label">ExclamationCircle2</span>
        </li>
        <li>
          <ExclamationTriangleLegacy />
          <span className="icon-label">ExclamationTriangle</span>
        </li>
        <li>
          <ExitLegacy />
          <span className="icon-label">Exit</span>
        </li>
        <li>
          <ExpandLegacy />
          <span className="icon-label">Expand</span>
        </li>
        <li>
          <ExpandOLegacy />
          <span className="icon-label">ExpandO</span>
        </li>
        <li>
          <ExpeditedsslLegacy />
          <span className="icon-label">Expeditedssl</span>
        </li>
        <li>
          <ExploreLegacy />
          <span className="icon-label">Explore</span>
        </li>
        <li>
          <ExportLegacy />
          <span className="icon-label">Export</span>
        </li>
        <li>
          <ExternalLinkLegacy />
          <span className="icon-label">ExternalLink</span>
        </li>
        <li>
          <ExternalLinkSquareLegacy />
          <span className="icon-label">ExternalLinkSquare</span>
        </li>
        <li>
          <EyeLegacy />
          <span className="icon-label">Eye</span>
        </li>
        <li>
          <EyedropperLegacy />
          <span className="icon-label">Eyedropper</span>
        </li>
        <li>
          <EyeSlashLegacy />
          <span className="icon-label">EyeSlash</span>
        </li>
        <li>
          <FaLegacy />
          <span className="icon-label">Fa</span>
        </li>
        <li>
          <FacebookLegacy />
          <span className="icon-label">Facebook</span>
        </li>
        <li>
          <FacebookOfficialLegacy />
          <span className="icon-label">FacebookOfficial</span>
        </li>
        <li>
          <FacebookSquareLegacy />
          <span className="icon-label">FacebookSquare</span>
        </li>
        <li>
          <FastBackwardLegacy />
          <span className="icon-label">FastBackward</span>
        </li>
        <li>
          <FastForwardLegacy />
          <span className="icon-label">FastForward</span>
        </li>
        <li>
          <FaxLegacy />
          <span className="icon-label">Fax</span>
        </li>
        <li>
          <FemaleLegacy />
          <span className="icon-label">Female</span>
        </li>
        <li>
          <FighterJetLegacy />
          <span className="icon-label">FighterJet</span>
        </li>
        <li>
          <FileLegacy />
          <span className="icon-label">File</span>
        </li>
        <li>
          <FileAudioOLegacy />
          <span className="icon-label">FileAudioO</span>
        </li>
        <li>
          <FileCodeOLegacy />
          <span className="icon-label">FileCodeO</span>
        </li>
        <li>
          <FileDownloadLegacy />
          <span className="icon-label">FileDownload</span>
        </li>
        <li>
          <FileExcelOLegacy />
          <span className="icon-label">FileExcelO</span>
        </li>
        <li>
          <FileImageOLegacy />
          <span className="icon-label">FileImageO</span>
        </li>
        <li>
          <FileMovieOLegacy />
          <span className="icon-label">FileMovieO</span>
        </li>
        <li>
          <FileOLegacy />
          <span className="icon-label">FileO</span>
        </li>
        <li>
          <FilePdfOLegacy />
          <span className="icon-label">FilePdfO</span>
        </li>
        <li>
          <FilePowerpointOLegacy />
          <span className="icon-label">FilePowerpointO</span>
        </li>
        <li>
          <FileTextLegacy />
          <span className="icon-label">FileText</span>
        </li>
        <li>
          <FileTextOLegacy />
          <span className="icon-label">FileTextO</span>
        </li>
        <li>
          <FileUploadLegacy />
          <span className="icon-label">FileUpload</span>
        </li>
        <li>
          <FileWordOLegacy />
          <span className="icon-label">FileWordO</span>
        </li>
        <li>
          <FileZipOLegacy />
          <span className="icon-label">FileZipO</span>
        </li>
        <li>
          <FilmLegacy />
          <span className="icon-label">Film</span>
        </li>
        <li>
          <FilterLegacy />
          <span className="icon-label">Filter</span>
        </li>
        <li>
          <FireLegacy />
          <span className="icon-label">Fire</span>
        </li>
        <li>
          <FireExtinguisherLegacy />
          <span className="icon-label">FireExtinguisher</span>
        </li>
        <li>
          <FirefoxLegacy />
          <span className="icon-label">Firefox</span>
        </li>
        <li>
          <FirstOrderLegacy />
          <span className="icon-label">FirstOrder</span>
        </li>
        <li>
          <FiveHundredPxLegacy />
          <span className="icon-label">FiveHundredPx</span>
        </li>
        <li>
          <FlagLegacy />
          <span className="icon-label">Flag</span>
        </li>
        <li>
          <FlagCheckeredLegacy />
          <span className="icon-label">FlagCheckered</span>
        </li>
        <li>
          <FlagOLegacy />
          <span className="icon-label">FlagO</span>
        </li>
        <li>
          <FlaskLegacy />
          <span className="icon-label">Flask</span>
        </li>
        <li>
          <FlickrLegacy />
          <span className="icon-label">Flickr</span>
        </li>
        <li>
          <FlowLegacy />
          <span className="icon-label">Flow</span>
        </li>
        <li>
          <FolderLegacy />
          <span className="icon-label">Folder</span>
        </li>
        <li>
          <FolderOLegacy />
          <span className="icon-label">FolderO</span>
        </li>
        <li>
          <FolderOpenLegacy />
          <span className="icon-label">FolderOpen</span>
        </li>
        <li>
          <FolderOpenOLegacy />
          <span className="icon-label">FolderOpenO</span>
        </li>
        <li>
          <FontLegacy />
          <span className="icon-label">Font</span>
        </li>
        <li>
          <FonticonsLegacy />
          <span className="icon-label">Fonticons</span>
        </li>
        <li>
          <FortAwesomeLegacy />
          <span className="icon-label">FortAwesome</span>
        </li>
        <li>
          <ForumbeeLegacy />
          <span className="icon-label">Forumbee</span>
        </li>
        <li>
          <ForwardLegacy />
          <span className="icon-label">Forward</span>
        </li>
        <li>
          <FoursquareLegacy />
          <span className="icon-label">Foursquare</span>
        </li>
        <li>
          <FrameLegacy />
          <span className="icon-label">Frame</span>
        </li>
        <li>
          <FreeCodeCampLegacy />
          <span className="icon-label">FreeCodeCamp</span>
        </li>
        <li>
          <FrownOLegacy />
          <span className="icon-label">FrownO</span>
        </li>
        <li>
          <FutbolOLegacy />
          <span className="icon-label">FutbolO</span>
        </li>
        <li>
          <GamepadLegacy />
          <span className="icon-label">Gamepad</span>
        </li>
        <li>
          <GavelLegacy />
          <span className="icon-label">Gavel</span>
        </li>
        <li>
          <GbpLegacy />
          <span className="icon-label">Gbp</span>
        </li>
        <li>
          <GeLegacy />
          <span className="icon-label">Ge</span>
        </li>
        <li>
          <GearLegacy />
          <span className="icon-label">Gear</span>
        </li>
        <li>
          <Gear2Legacy />
          <span className="icon-label">Gear2</span>
        </li>
        <li>
          <GearCircleLegacy />
          <span className="icon-label">GearCircle</span>
        </li>
        <li>
          <Gears2Legacy />
          <span className="icon-label">Gears2</span>
        </li>
        <li>
          <GenderlessLegacy />
          <span className="icon-label">Genderless</span>
        </li>
        <li>
          <GetPocketLegacy />
          <span className="icon-label">GetPocket</span>
        </li>
        <li>
          <GgLegacy />
          <span className="icon-label">Gg</span>
        </li>
        <li>
          <GgCircleLegacy />
          <span className="icon-label">GgCircle</span>
        </li>
        <li>
          <GiftLegacy />
          <span className="icon-label">Gift</span>
        </li>
        <li>
          <GitLegacy />
          <span className="icon-label">Git</span>
        </li>
        <li>
          <GithubLegacy />
          <span className="icon-label">Github</span>
        </li>
        <li>
          <GithubAltLegacy />
          <span className="icon-label">GithubAlt</span>
        </li>
        <li>
          <GithubSquareLegacy />
          <span className="icon-label">GithubSquare</span>
        </li>
        <li>
          <GitlabLegacy />
          <span className="icon-label">Gitlab</span>
        </li>
        <li>
          <GitSquareLegacy />
          <span className="icon-label">GitSquare</span>
        </li>
        <li>
          <GittipLegacy />
          <span className="icon-label">Gittip</span>
        </li>
        <li>
          <GlassLegacy />
          <span className="icon-label">Glass</span>
        </li>
        <li>
          <GlideLegacy />
          <span className="icon-label">Glide</span>
        </li>
        <li>
          <GlideGLegacy />
          <span className="icon-label">GlideG</span>
        </li>
        <li>
          <GlobeLegacy />
          <span className="icon-label">Globe</span>
        </li>
        <li>
          <Globe2Legacy />
          <span className="icon-label">Globe2</span>
        </li>
        <li>
          <GoodLegacy />
          <span className="icon-label">Good</span>
        </li>
        <li>
          <GoogleLegacy />
          <span className="icon-label">Google</span>
        </li>
        <li>
          <GooglePlusLegacy />
          <span className="icon-label">GooglePlus</span>
        </li>
        <li>
          <GooglePlusCircleLegacy />
          <span className="icon-label">GooglePlusCircle</span>
        </li>
        <li>
          <GooglePlusSquareLegacy />
          <span className="icon-label">GooglePlusSquare</span>
        </li>
        <li>
          <GoogleWalletLegacy />
          <span className="icon-label">GoogleWallet</span>
        </li>
        <li>
          <GravLegacy />
          <span className="icon-label">Grav</span>
        </li>
        <li>
          <GroupLegacy />
          <span className="icon-label">Group</span>
        </li>
        <li>
          <HandGrabOLegacy />
          <span className="icon-label">HandGrabO</span>
        </li>
        <li>
          <HandLizardOLegacy />
          <span className="icon-label">HandLizardO</span>
        </li>
        <li>
          <HandODownLegacy />
          <span className="icon-label">HandODown</span>
        </li>
        <li>
          <HandOLeftLegacy />
          <span className="icon-label">HandOLeft</span>
        </li>
        <li>
          <HandORightLegacy />
          <span className="icon-label">HandORight</span>
        </li>
        <li>
          <HandOUpLegacy />
          <span className="icon-label">HandOUp</span>
        </li>
        <li>
          <HandPeaceOLegacy />
          <span className="icon-label">HandPeaceO</span>
        </li>
        <li>
          <HandPointerOLegacy />
          <span className="icon-label">HandPointerO</span>
        </li>
        <li>
          <HandScissorsOLegacy />
          <span className="icon-label">HandScissorsO</span>
        </li>
        <li>
          <HandshakeOLegacy />
          <span className="icon-label">HandshakeO</span>
        </li>
        <li>
          <HandSpockOLegacy />
          <span className="icon-label">HandSpockO</span>
        </li>
        <li>
          <HandStopOLegacy />
          <span className="icon-label">HandStopO</span>
        </li>
        <li>
          <HashtagLegacy />
          <span className="icon-label">Hashtag</span>
        </li>
        <li>
          <HddOLegacy />
          <span className="icon-label">HddO</span>
        </li>
        <li>
          <HeaderLegacy />
          <span className="icon-label">Header</span>
        </li>
        <li>
          <HeadphonesLegacy />
          <span className="icon-label">Headphones</span>
        </li>
        <li>
          <HeartLegacy />
          <span className="icon-label">Heart</span>
        </li>
        <li>
          <HeartbeatLegacy />
          <span className="icon-label">Heartbeat</span>
        </li>
        <li>
          <HeartOLegacy />
          <span className="icon-label">HeartO</span>
        </li>
        <li>
          <HelpOLegacy />
          <span className="icon-label">HelpO</span>
        </li>
        <li>
          <HistoryLegacy />
          <span className="icon-label">History</span>
        </li>
        <li>
          <HomeLegacy />
          <span className="icon-label">Home</span>
        </li>
        <li>
          <HospitalOLegacy />
          <span className="icon-label">HospitalO</span>
        </li>
        <li>
          <HourglassLegacy />
          <span className="icon-label">Hourglass</span>
        </li>
        <li>
          <Hourglass1Legacy />
          <span className="icon-label">Hourglass1</span>
        </li>
        <li>
          <Hourglass2Legacy />
          <span className="icon-label">Hourglass2</span>
        </li>
        <li>
          <Hourglass3Legacy />
          <span className="icon-label">Hourglass3</span>
        </li>
        <li>
          <HourglassOLegacy />
          <span className="icon-label">HourglassO</span>
        </li>
        <li>
          <HouzzLegacy />
          <span className="icon-label">Houzz</span>
        </li>
        <li>
          <HSquareLegacy />
          <span className="icon-label">HSquare</span>
        </li>
        <li>
          <Html5Legacy />
          <span className="icon-label">Html5</span>
        </li>
        <li>
          <ICursorLegacy />
          <span className="icon-label">ICursor</span>
        </li>
        <li>
          <IdBadgeLegacy />
          <span className="icon-label">IdBadge</span>
        </li>
        <li>
          <IdCardLegacy />
          <span className="icon-label">IdCard</span>
        </li>
        <li>
          <IdCardOLegacy />
          <span className="icon-label">IdCardO</span>
        </li>
        <li>
          <IdInfoLegacy />
          <span className="icon-label">IdInfo</span>
        </li>
        <li>
          <IdMappingLegacy />
          <span className="icon-label">IdMapping</span>
        </li>
        <li>
          <IlsLegacy />
          <span className="icon-label">Ils</span>
        </li>
        <li>
          <ImageLegacy />
          <span className="icon-label">Image</span>
        </li>
        <li>
          <ImdbLegacy />
          <span className="icon-label">Imdb</span>
        </li>
        <li>
          <ImportLegacy />
          <span className="icon-label">Import</span>
        </li>
        <li>
          <InboxLegacy />
          <span className="icon-label">Inbox</span>
        </li>
        <li>
          <IndentLegacy />
          <span className="icon-label">Indent</span>
        </li>
        <li>
          <IndustryLegacy />
          <span className="icon-label">Industry</span>
        </li>
        <li>
          <InfoLegacy />
          <span className="icon-label">Info</span>
        </li>
        <li>
          <InfoCircleLegacy />
          <span className="icon-label">InfoCircle</span>
        </li>
        <li>
          <InrLegacy />
          <span className="icon-label">Inr</span>
        </li>
        <li>
          <InstagramLegacy />
          <span className="icon-label">Instagram</span>
        </li>
        <li>
          <InternetExplorerLegacy />
          <span className="icon-label">InternetExplorer</span>
        </li>
        <li>
          <IntersexLegacy />
          <span className="icon-label">Intersex</span>
        </li>
        <li>
          <IosLegacy />
          <span className="icon-label">Ios</span>
        </li>
        <li>
          <IoxhostLegacy />
          <span className="icon-label">Ioxhost</span>
        </li>
        <li>
          <ItalicLegacy />
          <span className="icon-label">Italic</span>
        </li>
        <li>
          <JoomlaLegacy />
          <span className="icon-label">Joomla</span>
        </li>
        <li>
          <JsfiddleLegacy />
          <span className="icon-label">Jsfiddle</span>
        </li>
        <li>
          <KeyLegacy />
          <span className="icon-label">Key</span>
        </li>
        <li>
          <KeyboardOLegacy />
          <span className="icon-label">KeyboardO</span>
        </li>
        <li>
          <KrwLegacy />
          <span className="icon-label">Krw</span>
        </li>
        <li>
          <LanguageLegacy />
          <span className="icon-label">Language</span>
        </li>
        <li>
          <LaptopLegacy />
          <span className="icon-label">Laptop</span>
        </li>
        <li>
          <LastfmLegacy />
          <span className="icon-label">Lastfm</span>
        </li>
        <li>
          <LastfmSquareLegacy />
          <span className="icon-label">LastfmSquare</span>
        </li>
        <li>
          <LeafLegacy />
          <span className="icon-label">Leaf</span>
        </li>
        <li>
          <LeanpubLegacy />
          <span className="icon-label">Leanpub</span>
        </li>
        <li>
          <LeftLegacy />
          <span className="icon-label">Left</span>
        </li>
        <li>
          <LemonOLegacy />
          <span className="icon-label">LemonO</span>
        </li>
        <li>
          <LevelDownLegacy />
          <span className="icon-label">LevelDown</span>
        </li>
        <li>
          <LevelUpLegacy />
          <span className="icon-label">LevelUp</span>
        </li>
        <li>
          <LightbulbOLegacy />
          <span className="icon-label">LightbulbO</span>
        </li>
        <li>
          <LineChartLegacy />
          <span className="icon-label">LineChart</span>
        </li>
        <li>
          <LinkLegacy />
          <span className="icon-label">Link</span>
        </li>
        <li>
          <LinkedinLegacy />
          <span className="icon-label">Linkedin</span>
        </li>
        <li>
          <LinkedinSquareLegacy />
          <span className="icon-label">LinkedinSquare</span>
        </li>
        <li>
          <LinodeLegacy />
          <span className="icon-label">Linode</span>
        </li>
        <li>
          <LinuxLegacy />
          <span className="icon-label">Linux</span>
        </li>
        <li>
          <ListLegacy />
          <span className="icon-label">List</span>
        </li>
        <li>
          <ListAltLegacy />
          <span className="icon-label">ListAlt</span>
        </li>
        <li>
          <ListOlLegacy />
          <span className="icon-label">ListOl</span>
        </li>
        <li>
          <ListUlLegacy />
          <span className="icon-label">ListUl</span>
        </li>
        <li>
          <LocationArrowLegacy />
          <span className="icon-label">LocationArrow</span>
        </li>
        <li>
          <LockLegacy />
          <span className="icon-label">Lock</span>
        </li>
        <li>
          <LogoAdsLegacy />
          <span className="icon-label">LogoAds</span>
        </li>
        <li>
          <LogoAnalyticsLegacy />
          <span className="icon-label">LogoAnalytics</span>
        </li>
        <li>
          <LogoDmpLegacy />
          <span className="icon-label">LogoDmp</span>
        </li>
        <li>
          <LogoMobileLegacy />
          <span className="icon-label">LogoMobile</span>
        </li>
        <li>
          <LogoShopLegacy />
          <span className="icon-label">LogoShop</span>
        </li>
        <li>
          <LogoSurveyLegacy />
          <span className="icon-label">LogoSurvey</span>
        </li>
        <li>
          <LogoVideoLegacy />
          <span className="icon-label">LogoVideo</span>
        </li>
        <li>
          <LongArrowDownLegacy />
          <span className="icon-label">LongArrowDown</span>
        </li>
        <li>
          <LongArrowLeftLegacy />
          <span className="icon-label">LongArrowLeft</span>
        </li>
        <li>
          <LongArrowRightLegacy />
          <span className="icon-label">LongArrowRight</span>
        </li>
        <li>
          <LongArrowUpLegacy />
          <span className="icon-label">LongArrowUp</span>
        </li>
        <li>
          <LowVisionLegacy />
          <span className="icon-label">LowVision</span>
        </li>
        <li>
          <MagicLegacy />
          <span className="icon-label">Magic</span>
        </li>
        <li>
          <Magic2Legacy />
          <span className="icon-label">Magic2</span>
        </li>
        <li>
          <MagnetLegacy />
          <span className="icon-label">Magnet</span>
        </li>
        <li>
          <MaleLegacy />
          <span className="icon-label">Male</span>
        </li>
        <li>
          <MapLegacy />
          <span className="icon-label">Map</span>
        </li>
        <li>
          <MapMarkerLegacy />
          <span className="icon-label">MapMarker</span>
        </li>
        <li>
          <MapOLegacy />
          <span className="icon-label">MapO</span>
        </li>
        <li>
          <MapPinLegacy />
          <span className="icon-label">MapPin</span>
        </li>
        <li>
          <MapSignsLegacy />
          <span className="icon-label">MapSigns</span>
        </li>
        <li>
          <MarsLegacy />
          <span className="icon-label">Mars</span>
        </li>
        <li>
          <MarsDoubleLegacy />
          <span className="icon-label">MarsDouble</span>
        </li>
        <li>
          <MarsStrokeLegacy />
          <span className="icon-label">MarsStroke</span>
        </li>
        <li>
          <MarsStrokeHLegacy />
          <span className="icon-label">MarsStrokeH</span>
        </li>
        <li>
          <MarsStrokeVLegacy />
          <span className="icon-label">MarsStrokeV</span>
        </li>
        <li>
          <MaxcdnLegacy />
          <span className="icon-label">Maxcdn</span>
        </li>
        <li>
          <MeanpathLegacy />
          <span className="icon-label">Meanpath</span>
        </li>
        <li>
          <MediumLegacy />
          <span className="icon-label">Medium</span>
        </li>
        <li>
          <MedkitLegacy />
          <span className="icon-label">Medkit</span>
        </li>
        <li>
          <MeetupLegacy />
          <span className="icon-label">Meetup</span>
        </li>
        <li>
          <MehOLegacy />
          <span className="icon-label">MehO</span>
        </li>
        <li>
          <MercuryLegacy />
          <span className="icon-label">Mercury</span>
        </li>
        <li>
          <MicrochipLegacy />
          <span className="icon-label">Microchip</span>
        </li>
        <li>
          <MicrophoneLegacy />
          <span className="icon-label">Microphone</span>
        </li>
        <li>
          <MicrophoneSlashLegacy />
          <span className="icon-label">MicrophoneSlash</span>
        </li>
        <li>
          <MinusLegacy />
          <span className="icon-label">Minus</span>
        </li>
        <li>
          <MinusCircleLegacy />
          <span className="icon-label">MinusCircle</span>
        </li>
        <li>
          <MinusSquareLegacy />
          <span className="icon-label">MinusSquare</span>
        </li>
        <li>
          <MinusSquareOLegacy />
          <span className="icon-label">MinusSquareO</span>
        </li>
        <li>
          <MixcloudLegacy />
          <span className="icon-label">Mixcloud</span>
        </li>
        <li>
          <MobileLegacy />
          <span className="icon-label">Mobile</span>
        </li>
        <li>
          <ModxLegacy />
          <span className="icon-label">Modx</span>
        </li>
        <li>
          <MoneyLegacy />
          <span className="icon-label">Money</span>
        </li>
        <li>
          <MoonOLegacy />
          <span className="icon-label">MoonO</span>
        </li>
        <li>
          <MoreLegacy />
          <span className="icon-label">More</span>
        </li>
        <li>
          <MortarBoardLegacy />
          <span className="icon-label">MortarBoard</span>
        </li>
        <li>
          <MotorcycleLegacy />
          <span className="icon-label">Motorcycle</span>
        </li>
        <li>
          <MousePointerLegacy />
          <span className="icon-label">MousePointer</span>
        </li>
        <li>
          <MultipleLinesChartLegacy />
          <span className="icon-label">MultipleLinesChart</span>
        </li>
        <li>
          <MusicLegacy />
          <span className="icon-label">Music</span>
        </li>
        <li>
          <NeuterLegacy />
          <span className="icon-label">Neuter</span>
        </li>
        <li>
          <NewspaperOLegacy />
          <span className="icon-label">NewspaperO</span>
        </li>
        <li>
          <ObjectGroupLegacy />
          <span className="icon-label">ObjectGroup</span>
        </li>
        <li>
          <ObjectUngroupLegacy />
          <span className="icon-label">ObjectUngroup</span>
        </li>
        <li>
          <OdnoklassnikiLegacy />
          <span className="icon-label">Odnoklassniki</span>
        </li>
        <li>
          <OdnoklassnikiSquareLegacy />
          <span className="icon-label">OdnoklassnikiSquare</span>
        </li>
        <li>
          <OffLegacy />
          <span className="icon-label">Off</span>
        </li>
        <li>
          <OkCircleLegacy />
          <span className="icon-label">OkCircle</span>
        </li>
        <li>
          <OpencartLegacy />
          <span className="icon-label">Opencart</span>
        </li>
        <li>
          <OpenidLegacy />
          <span className="icon-label">Openid</span>
        </li>
        <li>
          <OperaLegacy />
          <span className="icon-label">Opera</span>
        </li>
        <li>
          <OptinMonsterLegacy />
          <span className="icon-label">OptinMonster</span>
        </li>
        <li>
          <OrderFormLegacy />
          <span className="icon-label">OrderForm</span>
        </li>
        <li>
          <PageEndLegacy />
          <span className="icon-label">PageEnd</span>
        </li>
        <li>
          <PagelinesLegacy />
          <span className="icon-label">Pagelines</span>
        </li>
        <li>
          <PageNextLegacy />
          <span className="icon-label">PageNext</span>
        </li>
        <li>
          <PagePreviousLegacy />
          <span className="icon-label">PagePrevious</span>
        </li>
        <li>
          <PageTopLegacy />
          <span className="icon-label">PageTop</span>
        </li>
        <li>
          <PaintBrushLegacy />
          <span className="icon-label">PaintBrush</span>
        </li>
        <li>
          <PaperclipLegacy />
          <span className="icon-label">Paperclip</span>
        </li>
        <li>
          <ParagraphLegacy />
          <span className="icon-label">Paragraph</span>
        </li>
        <li>
          <PasteLegacy />
          <span className="icon-label">Paste</span>
        </li>
        <li>
          <PauseLegacy />
          <span className="icon-label">Pause</span>
        </li>
        <li>
          <PauseCircleLegacy />
          <span className="icon-label">PauseCircle</span>
        </li>
        <li>
          <PauseCircleOLegacy />
          <span className="icon-label">PauseCircleO</span>
        </li>
        <li>
          <PawLegacy />
          <span className="icon-label">Paw</span>
        </li>
        <li>
          <PaypalLegacy />
          <span className="icon-label">Paypal</span>
        </li>
        <li>
          <PcLegacy />
          <span className="icon-label">Pc</span>
        </li>
        <li>
          <PencilLegacy />
          <span className="icon-label">Pencil</span>
        </li>
        <li>
          <PencilSquareLegacy />
          <span className="icon-label">PencilSquare</span>
        </li>
        <li>
          <PeopleGroupLegacy />
          <span className="icon-label">PeopleGroup</span>
        </li>
        <li>
          <PeoplesLegacy />
          <span className="icon-label">Peoples</span>
        </li>
        <li>
          <PeoplesMapLegacy />
          <span className="icon-label">PeoplesMap</span>
        </li>
        <li>
          <PercentLegacy />
          <span className="icon-label">Percent</span>
        </li>
        <li>
          <PhoneLegacy />
          <span className="icon-label">Phone</span>
        </li>
        <li>
          <PhoneSquareLegacy />
          <span className="icon-label">PhoneSquare</span>
        </li>
        <li>
          <PieChartLegacy />
          <span className="icon-label">PieChart</span>
        </li>
        <li>
          <PiedPiperLegacy />
          <span className="icon-label">PiedPiper</span>
        </li>
        <li>
          <PiedPiperAltLegacy />
          <span className="icon-label">PiedPiperAlt</span>
        </li>
        <li>
          <PiedPiperPpLegacy />
          <span className="icon-label">PiedPiperPp</span>
        </li>
        <li>
          <PinterestLegacy />
          <span className="icon-label">Pinterest</span>
        </li>
        <li>
          <PinterestPLegacy />
          <span className="icon-label">PinterestP</span>
        </li>
        <li>
          <PinterestSquareLegacy />
          <span className="icon-label">PinterestSquare</span>
        </li>
        <li>
          <PlaneLegacy />
          <span className="icon-label">Plane</span>
        </li>
        <li>
          <PlayLegacy />
          <span className="icon-label">Play</span>
        </li>
        <li>
          <Play2Legacy />
          <span className="icon-label">Play2</span>
        </li>
        <li>
          <PlayCircleLegacy />
          <span className="icon-label">PlayCircle</span>
        </li>
        <li>
          <PlayCircleOLegacy />
          <span className="icon-label">PlayCircleO</span>
        </li>
        <li>
          <PlugLegacy />
          <span className="icon-label">Plug</span>
        </li>
        <li>
          <PlusLegacy />
          <span className="icon-label">Plus</span>
        </li>
        <li>
          <PlusCircleLegacy />
          <span className="icon-label">PlusCircle</span>
        </li>
        <li>
          <PlusSquareLegacy />
          <span className="icon-label">PlusSquare</span>
        </li>
        <li>
          <PlusSquareOLegacy />
          <span className="icon-label">PlusSquareO</span>
        </li>
        <li>
          <PodcastLegacy />
          <span className="icon-label">Podcast</span>
        </li>
        <li>
          <PowerOffLegacy />
          <span className="icon-label">PowerOff</span>
        </li>
        <li>
          <PrintLegacy />
          <span className="icon-label">Print</span>
        </li>
        <li>
          <ProductHuntLegacy />
          <span className="icon-label">ProductHunt</span>
        </li>
        <li>
          <ProfileLegacy />
          <span className="icon-label">Profile</span>
        </li>
        <li>
          <ProjectLegacy />
          <span className="icon-label">Project</span>
        </li>
        <li>
          <PublicOpinionLegacy />
          <span className="icon-label">PublicOpinion</span>
        </li>
        <li>
          <PuzzlePieceLegacy />
          <span className="icon-label">PuzzlePiece</span>
        </li>
        <li>
          <QqLegacy />
          <span className="icon-label">Qq</span>
        </li>
        <li>
          <QrcodeLegacy />
          <span className="icon-label">Qrcode</span>
        </li>
        <li>
          <QuestionLegacy />
          <span className="icon-label">Question</span>
        </li>
        <li>
          <Question2Legacy />
          <span className="icon-label">Question2</span>
        </li>
        <li>
          <QuestionCircleLegacy />
          <span className="icon-label">QuestionCircle</span>
        </li>
        <li>
          <QuestionCircle2Legacy />
          <span className="icon-label">QuestionCircle2</span>
        </li>
        <li>
          <QuoraLegacy />
          <span className="icon-label">Quora</span>
        </li>
        <li>
          <QuoteLeftLegacy />
          <span className="icon-label">QuoteLeft</span>
        </li>
        <li>
          <QuoteRightLegacy />
          <span className="icon-label">QuoteRight</span>
        </li>
        <li>
          <RaLegacy />
          <span className="icon-label">Ra</span>
        </li>
        <li>
          <RandomLegacy />
          <span className="icon-label">Random</span>
        </li>
        <li>
          <RateLegacy />
          <span className="icon-label">Rate</span>
        </li>
        <li>
          <RavelryLegacy />
          <span className="icon-label">Ravelry</span>
        </li>
        <li>
          <RealtimeLegacy />
          <span className="icon-label">Realtime</span>
        </li>
        <li>
          <RecycleLegacy />
          <span className="icon-label">Recycle</span>
        </li>
        <li>
          <RedditLegacy />
          <span className="icon-label">Reddit</span>
        </li>
        <li>
          <RedditAlienLegacy />
          <span className="icon-label">RedditAlien</span>
        </li>
        <li>
          <RedditSquareLegacy />
          <span className="icon-label">RedditSquare</span>
        </li>
        <li>
          <RefreshLegacy />
          <span className="icon-label">Refresh</span>
        </li>
        <li>
          <Refresh2Legacy />
          <span className="icon-label">Refresh2</span>
        </li>
        <li>
          <RegisteredLegacy />
          <span className="icon-label">Registered</span>
        </li>
        <li>
          <RelatedMapLegacy />
          <span className="icon-label">RelatedMap</span>
        </li>
        <li>
          <ReloadLegacy />
          <span className="icon-label">Reload</span>
        </li>
        <li>
          <RemindLegacy />
          <span className="icon-label">Remind</span>
        </li>
        <li>
          <RenrenLegacy />
          <span className="icon-label">Renren</span>
        </li>
        <li>
          <RepeatLegacy />
          <span className="icon-label">Repeat</span>
        </li>
        <li>
          <ReplyLegacy />
          <span className="icon-label">Reply</span>
        </li>
        <li>
          <ReplyAllLegacy />
          <span className="icon-label">ReplyAll</span>
        </li>
        <li>
          <RetentionLegacy />
          <span className="icon-label">Retention</span>
        </li>
        <li>
          <RetweetLegacy />
          <span className="icon-label">Retweet</span>
        </li>
        <li>
          <RightLegacy />
          <span className="icon-label">Right</span>
        </li>
        <li>
          <RoadLegacy />
          <span className="icon-label">Road</span>
        </li>
        <li>
          <RocketLegacy />
          <span className="icon-label">Rocket</span>
        </li>
        <li>
          <RssLegacy />
          <span className="icon-label">Rss</span>
        </li>
        <li>
          <RssSquareLegacy />
          <span className="icon-label">RssSquare</span>
        </li>
        <li>
          <RubLegacy />
          <span className="icon-label">Rub</span>
        </li>
        <li>
          <S15Legacy />
          <span className="icon-label">S15</span>
        </li>
        <li>
          <SafariLegacy />
          <span className="icon-label">Safari</span>
        </li>
        <li>
          <SalesLegacy />
          <span className="icon-label">Sales</span>
        </li>
        <li>
          <SaveLegacy />
          <span className="icon-label">Save</span>
        </li>
        <li>
          <ScribdLegacy />
          <span className="icon-label">Scribd</span>
        </li>
        <li>
          <SearchLegacy />
          <span className="icon-label">Search</span>
        </li>
        <li>
          <SearchMinusLegacy />
          <span className="icon-label">SearchMinus</span>
        </li>
        <li>
          <SearchPeoplesLegacy />
          <span className="icon-label">SearchPeoples</span>
        </li>
        <li>
          <SearchPlusLegacy />
          <span className="icon-label">SearchPlus</span>
        </li>
        <li>
          <SellsyLegacy />
          <span className="icon-label">Sellsy</span>
        </li>
        <li>
          <SendLegacy />
          <span className="icon-label">Send</span>
        </li>
        <li>
          <SendOLegacy />
          <span className="icon-label">SendO</span>
        </li>
        <li>
          <SequenceLegacy />
          <span className="icon-label">Sequence</span>
        </li>
        <li>
          <SequenceDownLegacy />
          <span className="icon-label">SequenceDown</span>
        </li>
        <li>
          <SequenceUpLegacy />
          <span className="icon-label">SequenceUp</span>
        </li>
        <li>
          <ServerLegacy />
          <span className="icon-label">Server</span>
        </li>
        <li>
          <SettingLegacy />
          <span className="icon-label">Setting</span>
        </li>
        <li>
          <ShapesLegacy />
          <span className="icon-label">Shapes</span>
        </li>
        <li>
          <ShareLegacy />
          <span className="icon-label">Share</span>
        </li>
        <li>
          <Share2Legacy />
          <span className="icon-label">Share2</span>
        </li>
        <li>
          <ShareAltLegacy />
          <span className="icon-label">ShareAlt</span>
        </li>
        <li>
          <ShareAltSquareLegacy />
          <span className="icon-label">ShareAltSquare</span>
        </li>
        <li>
          <ShareSquareLegacy />
          <span className="icon-label">ShareSquare</span>
        </li>
        <li>
          <ShareSquareOLegacy />
          <span className="icon-label">ShareSquareO</span>
        </li>
        <li>
          <ShieldLegacy />
          <span className="icon-label">Shield</span>
        </li>
        <li>
          <ShipLegacy />
          <span className="icon-label">Ship</span>
        </li>
        <li>
          <ShirtsinbulkLegacy />
          <span className="icon-label">Shirtsinbulk</span>
        </li>
        <li>
          <ShoppingBagLegacy />
          <span className="icon-label">ShoppingBag</span>
        </li>
        <li>
          <ShoppingBasketLegacy />
          <span className="icon-label">ShoppingBasket</span>
        </li>
        <li>
          <ShoppingCartLegacy />
          <span className="icon-label">ShoppingCart</span>
        </li>
        <li>
          <ShowerLegacy />
          <span className="icon-label">Shower</span>
        </li>
        <li>
          <SignalLegacy />
          <span className="icon-label">Signal</span>
        </li>
        <li>
          <SignInLegacy />
          <span className="icon-label">SignIn</span>
        </li>
        <li>
          <SigningLegacy />
          <span className="icon-label">Signing</span>
        </li>
        <li>
          <SignOutLegacy />
          <span className="icon-label">SignOut</span>
        </li>
        <li>
          <SimplybuiltLegacy />
          <span className="icon-label">Simplybuilt</span>
        </li>
        <li>
          <SitemapLegacy />
          <span className="icon-label">Sitemap</span>
        </li>
        <li>
          <SkyatlasLegacy />
          <span className="icon-label">Skyatlas</span>
        </li>
        <li>
          <SkypeLegacy />
          <span className="icon-label">Skype</span>
        </li>
        <li>
          <SlackLegacy />
          <span className="icon-label">Slack</span>
        </li>
        <li>
          <SlidersLegacy />
          <span className="icon-label">Sliders</span>
        </li>
        <li>
          <SlideshareLegacy />
          <span className="icon-label">Slideshare</span>
        </li>
        <li>
          <SmileOLegacy />
          <span className="icon-label">SmileO</span>
        </li>
        <li>
          <SnapchatLegacy />
          <span className="icon-label">Snapchat</span>
        </li>
        <li>
          <SnapchatGhostLegacy />
          <span className="icon-label">SnapchatGhost</span>
        </li>
        <li>
          <SnapchatSquareLegacy />
          <span className="icon-label">SnapchatSquare</span>
        </li>
        <li>
          <SnowflakeOLegacy />
          <span className="icon-label">SnowflakeO</span>
        </li>
        <li>
          <SortLegacy />
          <span className="icon-label">Sort</span>
        </li>
        <li>
          <SortAlphaAscLegacy />
          <span className="icon-label">SortAlphaAsc</span>
        </li>
        <li>
          <SortAlphaDescLegacy />
          <span className="icon-label">SortAlphaDesc</span>
        </li>
        <li>
          <SortAmountAscLegacy />
          <span className="icon-label">SortAmountAsc</span>
        </li>
        <li>
          <SortAmountDescLegacy />
          <span className="icon-label">SortAmountDesc</span>
        </li>
        <li>
          <SortDescLegacy />
          <span className="icon-label">SortDesc</span>
        </li>
        <li>
          <SortNumericAscLegacy />
          <span className="icon-label">SortNumericAsc</span>
        </li>
        <li>
          <SortNumericDescLegacy />
          <span className="icon-label">SortNumericDesc</span>
        </li>
        <li>
          <SortUpLegacy />
          <span className="icon-label">SortUp</span>
        </li>
        <li>
          <SoundcloudLegacy />
          <span className="icon-label">Soundcloud</span>
        </li>
        <li>
          <SpaceShuttleLegacy />
          <span className="icon-label">SpaceShuttle</span>
        </li>
        <li>
          <SpeakerLegacy />
          <span className="icon-label">Speaker</span>
        </li>
        <li>
          <SpinnerLegacy />
          <span className="icon-label">Spinner</span>
        </li>
        <li>
          <SpoonLegacy />
          <span className="icon-label">Spoon</span>
        </li>
        <li>
          <SpotifyLegacy />
          <span className="icon-label">Spotify</span>
        </li>
        <li>
          <SquareLegacy />
          <span className="icon-label">Square</span>
        </li>
        <li>
          <SquareOLegacy />
          <span className="icon-label">SquareO</span>
        </li>
        <li>
          <SquaresLegacy />
          <span className="icon-label">Squares</span>
        </li>
        <li>
          <StackExchangeLegacy />
          <span className="icon-label">StackExchange</span>
        </li>
        <li>
          <StackOverflowLegacy />
          <span className="icon-label">StackOverflow</span>
        </li>
        <li>
          <StarLegacy />
          <span className="icon-label">Star</span>
        </li>
        <li>
          <StarHalfLegacy />
          <span className="icon-label">StarHalf</span>
        </li>
        <li>
          <StarHalfOLegacy />
          <span className="icon-label">StarHalfO</span>
        </li>
        <li>
          <StarOLegacy />
          <span className="icon-label">StarO</span>
        </li>
        <li>
          <SteamLegacy />
          <span className="icon-label">Steam</span>
        </li>
        <li>
          <SteamSquareLegacy />
          <span className="icon-label">SteamSquare</span>
        </li>
        <li>
          <StepBackwardLegacy />
          <span className="icon-label">StepBackward</span>
        </li>
        <li>
          <StepForwardLegacy />
          <span className="icon-label">StepForward</span>
        </li>
        <li>
          <StethoscopeLegacy />
          <span className="icon-label">Stethoscope</span>
        </li>
        <li>
          <StickyNoteLegacy />
          <span className="icon-label">StickyNote</span>
        </li>
        <li>
          <StickyNoteOLegacy />
          <span className="icon-label">StickyNoteO</span>
        </li>
        <li>
          <StopLegacy />
          <span className="icon-label">Stop</span>
        </li>
        <li>
          <Stop2Legacy />
          <span className="icon-label">Stop2</span>
        </li>
        <li>
          <StopCircleLegacy />
          <span className="icon-label">StopCircle</span>
        </li>
        <li>
          <StopCircleOLegacy />
          <span className="icon-label">StopCircleO</span>
        </li>
        <li>
          <StreetViewLegacy />
          <span className="icon-label">StreetView</span>
        </li>
        <li>
          <StrikethroughLegacy />
          <span className="icon-label">Strikethrough</span>
        </li>
        <li>
          <StumbleuponLegacy />
          <span className="icon-label">Stumbleupon</span>
        </li>
        <li>
          <StumbleuponCircleLegacy />
          <span className="icon-label">StumbleuponCircle</span>
        </li>
        <li>
          <SubscriptLegacy />
          <span className="icon-label">Subscript</span>
        </li>
        <li>
          <SubwayLegacy />
          <span className="icon-label">Subway</span>
        </li>
        <li>
          <SuitcaseLegacy />
          <span className="icon-label">Suitcase</span>
        </li>
        <li>
          <SunOLegacy />
          <span className="icon-label">SunO</span>
        </li>
        <li>
          <SuperpowersLegacy />
          <span className="icon-label">Superpowers</span>
        </li>
        <li>
          <SuperscriptLegacy />
          <span className="icon-label">Superscript</span>
        </li>
        <li>
          <SupportLegacy />
          <span className="icon-label">Support</span>
        </li>
        <li>
          <TableLegacy />
          <span className="icon-label">Table</span>
        </li>
        <li>
          <TabletLegacy />
          <span className="icon-label">Tablet</span>
        </li>
        <li>
          <TagLegacy />
          <span className="icon-label">Tag</span>
        </li>
        <li>
          <TagAreaLegacy />
          <span className="icon-label">TagArea</span>
        </li>
        <li>
          <TagAuthorizeLegacy />
          <span className="icon-label">TagAuthorize</span>
        </li>
        <li>
          <TagsLegacy />
          <span className="icon-label">Tags</span>
        </li>
        <li>
          <TagUnauthorizeLegacy />
          <span className="icon-label">TagUnauthorize</span>
        </li>
        <li>
          <TargetLegacy />
          <span className="icon-label">Target</span>
        </li>
        <li>
          <TaskLegacy />
          <span className="icon-label">Task</span>
        </li>
        <li>
          <TasksLegacy />
          <span className="icon-label">Tasks</span>
        </li>
        <li>
          <TelegramLegacy />
          <span className="icon-label">Telegram</span>
        </li>
        <li>
          <TencentWeiboLegacy />
          <span className="icon-label">TencentWeibo</span>
        </li>
        <li>
          <TerminalLegacy />
          <span className="icon-label">Terminal</span>
        </li>
        <li>
          <TerminalLineLegacy />
          <span className="icon-label">TerminalLine</span>
        </li>
        <li>
          <TextHeightLegacy />
          <span className="icon-label">TextHeight</span>
        </li>
        <li>
          <TextWidthLegacy />
          <span className="icon-label">TextWidth</span>
        </li>
        <li>
          <ThLegacy />
          <span className="icon-label">Th</span>
        </li>
        <li>
          <Th2Legacy />
          <span className="icon-label">Th2</span>
        </li>
        <li>
          <ThemeisleLegacy />
          <span className="icon-label">Themeisle</span>
        </li>
        <li>
          <ThermometerLegacy />
          <span className="icon-label">Thermometer</span>
        </li>
        <li>
          <Thermometer0Legacy />
          <span className="icon-label">Thermometer0</span>
        </li>
        <li>
          <Thermometer1Legacy />
          <span className="icon-label">Thermometer1</span>
        </li>
        <li>
          <Thermometer2Legacy />
          <span className="icon-label">Thermometer2</span>
        </li>
        <li>
          <Thermometer3Legacy />
          <span className="icon-label">Thermometer3</span>
        </li>
        <li>
          <ThLargeLegacy />
          <span className="icon-label">ThLarge</span>
        </li>
        <li>
          <ThListLegacy />
          <span className="icon-label">ThList</span>
        </li>
        <li>
          <ThumbsDownLegacy />
          <span className="icon-label">ThumbsDown</span>
        </li>
        <li>
          <ThumbsODownLegacy />
          <span className="icon-label">ThumbsODown</span>
        </li>
        <li>
          <ThumbsOUpLegacy />
          <span className="icon-label">ThumbsOUp</span>
        </li>
        <li>
          <ThumbsUpLegacy />
          <span className="icon-label">ThumbsUp</span>
        </li>
        <li>
          <ThumbTackLegacy />
          <span className="icon-label">ThumbTack</span>
        </li>
        <li>
          <TicketLegacy />
          <span className="icon-label">Ticket</span>
        </li>
        <li>
          <TimesCircleLegacy />
          <span className="icon-label">TimesCircle</span>
        </li>
        <li>
          <TimesCircleOLegacy />
          <span className="icon-label">TimesCircleO</span>
        </li>
        <li>
          <TintLegacy />
          <span className="icon-label">Tint</span>
        </li>
        <li>
          <TmallLegacy />
          <span className="icon-label">Tmall</span>
        </li>
        <li>
          <ToggleDownLegacy />
          <span className="icon-label">ToggleDown</span>
        </li>
        <li>
          <ToggleLeftLegacy />
          <span className="icon-label">ToggleLeft</span>
        </li>
        <li>
          <ToggleOffLegacy />
          <span className="icon-label">ToggleOff</span>
        </li>
        <li>
          <ToggleOnLegacy />
          <span className="icon-label">ToggleOn</span>
        </li>
        <li>
          <ToggleRightLegacy />
          <span className="icon-label">ToggleRight</span>
        </li>
        <li>
          <ToggleUpLegacy />
          <span className="icon-label">ToggleUp</span>
        </li>
        <li>
          <TrademarkLegacy />
          <span className="icon-label">Trademark</span>
        </li>
        <li>
          <TrainLegacy />
          <span className="icon-label">Train</span>
        </li>
        <li>
          <TransgenderAltLegacy />
          <span className="icon-label">TransgenderAlt</span>
        </li>
        <li>
          <TrashLegacy />
          <span className="icon-label">Trash</span>
        </li>
        <li>
          <Trash2Legacy />
          <span className="icon-label">Trash2</span>
        </li>
        <li>
          <TrashOLegacy />
          <span className="icon-label">TrashO</span>
        </li>
        <li>
          <TreeLegacy />
          <span className="icon-label">Tree</span>
        </li>
        <li>
          <TreeCloseLegacy />
          <span className="icon-label">TreeClose</span>
        </li>
        <li>
          <TreeOpenLegacy />
          <span className="icon-label">TreeOpen</span>
        </li>
        <li>
          <TrelloLegacy />
          <span className="icon-label">Trello</span>
        </li>
        <li>
          <TrendLegacy />
          <span className="icon-label">Trend</span>
        </li>
        <li>
          <TripadvisorLegacy />
          <span className="icon-label">Tripadvisor</span>
        </li>
        <li>
          <TrophyLegacy />
          <span className="icon-label">Trophy</span>
        </li>
        <li>
          <TruckLegacy />
          <span className="icon-label">Truck</span>
        </li>
        <li>
          <TryLegacy />
          <span className="icon-label">Try</span>
        </li>
        <li>
          <TtyLegacy />
          <span className="icon-label">Tty</span>
        </li>
        <li>
          <TumblrLegacy />
          <span className="icon-label">Tumblr</span>
        </li>
        <li>
          <TumblrSquareLegacy />
          <span className="icon-label">TumblrSquare</span>
        </li>
        <li>
          <TvLegacy />
          <span className="icon-label">Tv</span>
        </li>
        <li>
          <TwinkleStarLegacy />
          <span className="icon-label">TwinkleStar</span>
        </li>
        <li>
          <TwitchLegacy />
          <span className="icon-label">Twitch</span>
        </li>
        <li>
          <TwitterLegacy />
          <span className="icon-label">Twitter</span>
        </li>
        <li>
          <TwitterSquareLegacy />
          <span className="icon-label">TwitterSquare</span>
        </li>
        <li>
          <UmbrellaLegacy />
          <span className="icon-label">Umbrella</span>
        </li>
        <li>
          <UnderlineLegacy />
          <span className="icon-label">Underline</span>
        </li>
        <li>
          <UndoLegacy />
          <span className="icon-label">Undo</span>
        </li>
        <li>
          <UniversalAccessLegacy />
          <span className="icon-label">UniversalAccess</span>
        </li>
        <li>
          <UnlinkLegacy />
          <span className="icon-label">Unlink</span>
        </li>
        <li>
          <UnlockLegacy />
          <span className="icon-label">Unlock</span>
        </li>
        <li>
          <UnlockAltLegacy />
          <span className="icon-label">UnlockAlt</span>
        </li>
        <li>
          <UpLegacy />
          <span className="icon-label">Up</span>
        </li>
        <li>
          <UploadLegacy />
          <span className="icon-label">Upload</span>
        </li>
        <li>
          <Upload2Legacy />
          <span className="icon-label">Upload2</span>
        </li>
        <li>
          <UsbLegacy />
          <span className="icon-label">Usb</span>
        </li>
        <li>
          <UsdLegacy />
          <span className="icon-label">Usd</span>
        </li>
        <li>
          <UserLegacy />
          <span className="icon-label">User</span>
        </li>
        <li>
          <UserAnalysisLegacy />
          <span className="icon-label">UserAnalysis</span>
        </li>
        <li>
          <UserCircleLegacy />
          <span className="icon-label">UserCircle</span>
        </li>
        <li>
          <UserCircleOLegacy />
          <span className="icon-label">UserCircleO</span>
        </li>
        <li>
          <UserInfoLegacy />
          <span className="icon-label">UserInfo</span>
        </li>
        <li>
          <UserMdLegacy />
          <span className="icon-label">UserMd</span>
        </li>
        <li>
          <UserOLegacy />
          <span className="icon-label">UserO</span>
        </li>
        <li>
          <UserPlusLegacy />
          <span className="icon-label">UserPlus</span>
        </li>
        <li>
          <UserSecretLegacy />
          <span className="icon-label">UserSecret</span>
        </li>
        <li>
          <UserTimesLegacy />
          <span className="icon-label">UserTimes</span>
        </li>
        <li>
          <VcardLegacy />
          <span className="icon-label">Vcard</span>
        </li>
        <li>
          <VcardOLegacy />
          <span className="icon-label">VcardO</span>
        </li>
        <li>
          <VenusLegacy />
          <span className="icon-label">Venus</span>
        </li>
        <li>
          <VenusDoubleLegacy />
          <span className="icon-label">VenusDouble</span>
        </li>
        <li>
          <VenusMarsLegacy />
          <span className="icon-label">VenusMars</span>
        </li>
        <li>
          <ViacoinLegacy />
          <span className="icon-label">Viacoin</span>
        </li>
        <li>
          <ViadeoLegacy />
          <span className="icon-label">Viadeo</span>
        </li>
        <li>
          <ViadeoSquareLegacy />
          <span className="icon-label">ViadeoSquare</span>
        </li>
        <li>
          <VideoCameraLegacy />
          <span className="icon-label">VideoCamera</span>
        </li>
        <li>
          <ViewsAuthorizeLegacy />
          <span className="icon-label">ViewsAuthorize</span>
        </li>
        <li>
          <ViewsUnauthorizeLegacy />
          <span className="icon-label">ViewsUnauthorize</span>
        </li>
        <li>
          <VimeoLegacy />
          <span className="icon-label">Vimeo</span>
        </li>
        <li>
          <VimeoSquareLegacy />
          <span className="icon-label">VimeoSquare</span>
        </li>
        <li>
          <VineLegacy />
          <span className="icon-label">Vine</span>
        </li>
        <li>
          <VkLegacy />
          <span className="icon-label">Vk</span>
        </li>
        <li>
          <VolumeControlPhoneLegacy />
          <span className="icon-label">VolumeControlPhone</span>
        </li>
        <li>
          <VolumeDownLegacy />
          <span className="icon-label">VolumeDown</span>
        </li>
        <li>
          <VolumeOffLegacy />
          <span className="icon-label">VolumeOff</span>
        </li>
        <li>
          <VolumeUpLegacy />
          <span className="icon-label">VolumeUp</span>
        </li>
        <li>
          <WarningLegacy />
          <span className="icon-label">Warning</span>
        </li>
        <li>
          <WeappLegacy />
          <span className="icon-label">Weapp</span>
        </li>
        <li>
          <WebLegacy />
          <span className="icon-label">Web</span>
        </li>
        <li>
          <WechatLegacy />
          <span className="icon-label">Wechat</span>
        </li>
        <li>
          <WeiboLegacy />
          <span className="icon-label">Weibo</span>
        </li>
        <li>
          <WhatsappLegacy />
          <span className="icon-label">Whatsapp</span>
        </li>
        <li>
          <WheelchairLegacy />
          <span className="icon-label">Wheelchair</span>
        </li>
        <li>
          <WheelchairAltLegacy />
          <span className="icon-label">WheelchairAlt</span>
        </li>
        <li>
          <WifiLegacy />
          <span className="icon-label">Wifi</span>
        </li>
        <li>
          <WikipediaWLegacy />
          <span className="icon-label">WikipediaW</span>
        </li>
        <li>
          <WindowCloseLegacy />
          <span className="icon-label">WindowClose</span>
        </li>
        <li>
          <WindowCloseOLegacy />
          <span className="icon-label">WindowCloseO</span>
        </li>
        <li>
          <WindowMaximizeLegacy />
          <span className="icon-label">WindowMaximize</span>
        </li>
        <li>
          <WindowMinimizeLegacy />
          <span className="icon-label">WindowMinimize</span>
        </li>
        <li>
          <WindowRestoreLegacy />
          <span className="icon-label">WindowRestore</span>
        </li>
        <li>
          <WindowsLegacy />
          <span className="icon-label">Windows</span>
        </li>
        <li>
          <WordpressLegacy />
          <span className="icon-label">Wordpress</span>
        </li>
        <li>
          <WpbeginnerLegacy />
          <span className="icon-label">Wpbeginner</span>
        </li>
        <li>
          <WpexplorerLegacy />
          <span className="icon-label">Wpexplorer</span>
        </li>
        <li>
          <WpformsLegacy />
          <span className="icon-label">Wpforms</span>
        </li>
        <li>
          <WrenchLegacy />
          <span className="icon-label">Wrench</span>
        </li>
        <li>
          <XingLegacy />
          <span className="icon-label">Xing</span>
        </li>
        <li>
          <XingSquareLegacy />
          <span className="icon-label">XingSquare</span>
        </li>
        <li>
          <YahooLegacy />
          <span className="icon-label">Yahoo</span>
        </li>
        <li>
          <YcLegacy />
          <span className="icon-label">Yc</span>
        </li>
        <li>
          <YcSquareLegacy />
          <span className="icon-label">YcSquare</span>
        </li>
        <li>
          <YelpLegacy />
          <span className="icon-label">Yelp</span>
        </li>
        <li>
          <YoastLegacy />
          <span className="icon-label">Yoast</span>
        </li>
        <li>
          <YoutubeLegacy />
          <span className="icon-label">Youtube</span>
        </li>
        <li>
          <YoutubePlayLegacy />
          <span className="icon-label">YoutubePlay</span>
        </li>
        <li>
          <YoutubeSquareLegacy />
          <span className="icon-label">YoutubeSquare</span>
        </li>
      </ul>
      <h3>network</h3>
      <ul>
        <li>
          <CloudReflash />
          <span className="icon-label">CloudReflash</span>
        </li>
        <li>
          <Export />
          <span className="icon-label">Export</span>
        </li>
        <li>
          <Global />
          <span className="icon-label">Global</span>
        </li>
        <li>
          <Import />
          <span className="icon-label">Import</span>
        </li>
      </ul>
      <h3>people</h3>
      <ul>
        <li>
          <Admin />
          <span className="icon-label">Admin</span>
        </li>
        <li>
          <CharacterAuthorize />
          <span className="icon-label">CharacterAuthorize</span>
        </li>
        <li>
          <CharacterLock />
          <span className="icon-label">CharacterLock</span>
        </li>
        <li>
          <IdInfo />
          <span className="icon-label">IdInfo</span>
        </li>
        <li>
          <IdMapping />
          <span className="icon-label">IdMapping</span>
        </li>
        <li>
          <Location />
          <span className="icon-label">Location</span>
        </li>
        <li>
          <Member />
          <span className="icon-label">Member</span>
        </li>
        <li>
          <OperatePeople />
          <span className="icon-label">OperatePeople</span>
        </li>
        <li>
          <PeopleBranch />
          <span className="icon-label">PeopleBranch</span>
        </li>
        <li>
          <PeopleExpand />
          <span className="icon-label">PeopleExpand</span>
        </li>
        <li>
          <PeopleFliter />
          <span className="icon-label">PeopleFliter</span>
        </li>
        <li>
          <Peoples />
          <span className="icon-label">Peoples</span>
        </li>
        <li>
          <PeoplesCostomize />
          <span className="icon-label">PeoplesCostomize</span>
        </li>
        <li>
          <PeoplesMap />
          <span className="icon-label">PeoplesMap</span>
        </li>
        <li>
          <PeopleSpeaker />
          <span className="icon-label">PeopleSpeaker</span>
        </li>
        <li>
          <PeoplesUploaded />
          <span className="icon-label">PeoplesUploaded</span>
        </li>
        <li>
          <SearchPeople />
          <span className="icon-label">SearchPeople</span>
        </li>
        <li>
          <SentToUser />
          <span className="icon-label">SentToUser</span>
        </li>
        <li>
          <UserBadge />
          <span className="icon-label">UserBadge</span>
        </li>
        <li>
          <UserChange />
          <span className="icon-label">UserChange</span>
        </li>
        <li>
          <UserInfo />
          <span className="icon-label">UserInfo</span>
        </li>
      </ul>
      <h3>platform</h3>
      <ul>
        <li>
          <Alipay />
          <span className="icon-label">Alipay</span>
        </li>
        <li>
          <Android />
          <span className="icon-label">Android</span>
        </li>
        <li>
          <IOs />
          <span className="icon-label">IOs</span>
        </li>
        <li>
          <MiniProgram />
          <span className="icon-label">MiniProgram</span>
        </li>
        <li>
          <Taobao />
          <span className="icon-label">Taobao</span>
        </li>
        <li>
          <Tmall />
          <span className="icon-label">Tmall</span>
        </li>
        <li>
          <Wechat />
          <span className="icon-label">Wechat</span>
        </li>
        <li>
          <WechatOutline />
          <span className="icon-label">WechatOutline</span>
        </li>
        <li>
          <WechatTemplate />
          <span className="icon-label">WechatTemplate</span>
        </li>
      </ul>
      <h3>status</h3>
      <ul>
        <li>
          <BlockRound />
          <span className="icon-label">BlockRound</span>
        </li>
        <li>
          <CheckRound />
          <span className="icon-label">CheckRound</span>
        </li>
        <li>
          <DoingRound />
          <span className="icon-label">DoingRound</span>
        </li>
        <li>
          <DraftRound />
          <span className="icon-label">DraftRound</span>
        </li>
        <li>
          <ExpiredRound />
          <span className="icon-label">ExpiredRound</span>
        </li>
        <li>
          <EyeClose />
          <span className="icon-label">EyeClose</span>
        </li>
        <li>
          <HelpOutline />
          <span className="icon-label">HelpOutline</span>
        </li>
        <li>
          <InfoOutline />
          <span className="icon-label">InfoOutline</span>
        </li>
        <li>
          <InfoRound />
          <span className="icon-label">InfoRound</span>
        </li>
        <li>
          <MinusRound />
          <span className="icon-label">MinusRound</span>
        </li>
        <li>
          <Notice />
          <span className="icon-label">Notice</span>
        </li>
        <li>
          <PauseRound />
          <span className="icon-label">PauseRound</span>
        </li>
        <li>
          <Pin />
          <span className="icon-label">Pin</span>
        </li>
        <li>
          <Pined />
          <span className="icon-label">Pined</span>
        </li>
        <li>
          <PlusRound />
          <span className="icon-label">PlusRound</span>
        </li>
        <li>
          <ReadyRound />
          <span className="icon-label">ReadyRound</span>
        </li>
        <li>
          <RemindFill />
          <span className="icon-label">RemindFill</span>
        </li>
        <li>
          <RemindOutline />
          <span className="icon-label">RemindOutline</span>
        </li>
        <li>
          <RemindRound />
          <span className="icon-label">RemindRound</span>
        </li>
        <li>
          <RunningRound />
          <span className="icon-label">RunningRound</span>
        </li>
        <li>
          <TimeRound />
          <span className="icon-label">TimeRound</span>
        </li>
        <li>
          <Unvisible />
          <span className="icon-label">Unvisible</span>
        </li>
        <li>
          <UpdateRound />
          <span className="icon-label">UpdateRound</span>
        </li>
        <li>
          <VerifyRound />
          <span className="icon-label">VerifyRound</span>
        </li>
        <li>
          <Visible />
          <span className="icon-label">Visible</span>
        </li>
        <li>
          <WarningRound />
          <span className="icon-label">WarningRound</span>
        </li>
      </ul>
      <h3>time</h3>
      <ul>
        <li>
          <Calendar />
          <span className="icon-label">Calendar</span>
        </li>
        <li>
          <EventDetail />
          <span className="icon-label">EventDetail</span>
        </li>
        <li>
          <History />
          <span className="icon-label">History</span>
        </li>
        <li>
          <Time />
          <span className="icon-label">Time</span>
        </li>
      </ul>
    </div>
  );
};

export default IconList;
